// src/components/contact-host/contact-host.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ConfirmationScreenFragment on InquiryResponse {\n    __typename\n    header\n    body\n    analytics {\n      linkName\n      referrerId\n    }\n    doneButton {\n      ... on UIPrimaryButton {\n        accessibility\n        primary\n        analytics {\n          linkName\n          referrerId\n        }\n        disabled\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment InquiryFormButtonFragment on UIPrimaryButton {\n    __typename\n    primary\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    disabled\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment InquiryFormDateRangePickerFragment on EGDSDateRangePicker {\n    __typename\n    buttonText\n    clearButtonText\n    firstDayOfWeek\n    endDateButtonAnalytics {\n      linkName\n      referrerId\n    }\n    startDateButtonAnalytics {\n      linkName\n      referrerId\n    }\n    nextButtonAnalytics {\n      linkName\n      referrerId\n    }\n    previousButtonAnalytics {\n      linkName\n      referrerId\n    }\n    submitButtonAnalytics {\n      linkName\n      referrerId\n    }\n    maxNumberOfDaysSelected\n    sameDaySelectionAllowed\n    selectedStartDate {\n      ...DateFragment\n    }\n    startDatePlaceholderText\n    selectedEndDate {\n      ...DateFragment\n    }\n    endDatePlaceholderText\n    validDaysLowerBoundInclusive {\n      ...DateFragment\n    }\n    validDaysUpperBoundInclusive {\n      ...DateFragment\n    }\n    dateFormat\n  }\n\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSInlineLinkFragment on EGDSInlineLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    disabled\n    linkSize: size\n    text\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSParagraphFragment on EGDSParagraph {\n    __typename\n    text\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    __typename\n    text\n    theme\n    weight\n    size\n    decorative\n    accessibility\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSTextFragment on EGDSText {\n    ... on EGDSParagraph {\n      ...LodgingEGDSParagraphFragment\n    }\n    ... on EGDSStylizedText {\n      ...EGDSStylizedTextFragment\n    }\n    ... on EGDSPlainText {\n      __typename\n      text\n    }\n    ... on EGDSInlineLink {\n      ...LodgingEGDSInlineLinkFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSHeadingFragment on EGDSHeading {\n    __typename\n    text\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    contents {\n      ...EGDSSpannableTextContentFragment\n    }\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSLocalizedTextTemplateFragment on EGDSLocalizedTextTemplate {\n    __typename\n    template\n    token\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  fragment InquiryFormDisclaimerFragment on InquiryFormLayout {\n    disclaimer {\n      __typename\n      ...LodgingEGDSTextFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSMaxLengthInputValidationFragment on EGDSMaxLengthInputValidation {\n    errorMessage\n    maxLength\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSMinLengthInputValidationFragment on EGDSMinLengthInputValidation {\n    errorMessage\n    minLength\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSRegexInputValidationFragment on EGDSRegexInputValidation {\n    errorMessage\n    pattern\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSRequiredInputValidationFragment on EGDSRequiredInputValidation {\n    errorMessage\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSInputValidationFragment on EGDSInputValidation {\n    ...EGDSRegexInputValidationFragment\n    ...EGDSMaxLengthInputValidationFragment\n    ...EGDSMinLengthInputValidationFragment\n    ...EGDSRequiredInputValidationFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSBasicCheckBoxFragment on EGDSBasicCheckBox {\n    egdsElementId\n    description\n    enabled\n    checkedAnalytics {\n      linkName\n      referrerId\n    }\n    uncheckedAnalytics {\n      linkName\n      referrerId\n    }\n    checkboxLabel: label {\n      text\n    }\n    name\n    required\n    state\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSInputTextFragment on EGDSTextInputField {\n    __typename\n    egdsElementId\n    inputDisabled: disabled\n    label\n    readOnly\n    value\n    placeholder\n    validations {\n      ...EGDSInputValidationFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  fragment InquiryFormTextAreaFragment on EGDSTextAreaInputField {\n    egdsElementId\n    label\n    readOnly\n    errorMessage\n    minRows\n    maxRows\n    value\n    placeholder\n    validations {\n      ...EGDSInputValidationFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSPrimaryButtonFragment on UIPrimaryButton {\n    egdsElementId\n    ... on EGDSButton {\n      primary\n      disabled\n      accessibility\n      icon {\n        id\n        description\n        token\n        title\n      }\n      analytics {\n        linkName\n        referrerId\n      }\n      action {\n        accessibility\n      }\n    }\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSErrorSummaryFragment on EGDSErrorSummary {\n    egdsElementId\n    goToErrorLinkText\n    goToFirstErrorLinkText\n    heading\n    body {\n      text\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    impressionAnalytics {\n      linkName\n      referrerId\n    }\n    headingTemplate {\n      ... on EGDSCardinalLocalizedText {\n        models {\n          key\n          source\n        }\n        templates {\n          category\n          template\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSBasicOptionFragment on EGDSBasicOption {\n    label\n    value\n    egdsElementId\n    changeAnalytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSTravelerChildAgeSelectFragment on EGDSTravelerChildAgeSelect {\n    labelTemplate {\n      ... on EGDSBasicLocalizedText {\n        models {\n          key\n          source\n        }\n        template\n      }\n    }\n    options {\n      ...EGDSBasicOptionFragment\n    }\n    egdsElementId\n    value\n  }\n\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSTravelerStepInputFragment on EGDSStepInput {\n    ... on EGDSTravelerStepInput {\n      decreaseAnalytics {\n        linkName\n        referrerId\n      }\n      increaseAnalytics {\n        linkName\n        referrerId\n      }\n      decreaseText\n      decreaseTextTemplate {\n        ...EGDSBasicLocalizedTextFragment\n      }\n      increaseText\n      increaseTextTemplate {\n        ...EGDSBasicLocalizedTextFragment\n      }\n      egdsElementId\n    }\n    label\n    max\n    min\n    step\n    subLabel\n    value\n  }\n\n  fragment EGDSBasicLocalizedTextFragment on EGDSBasicLocalizedText {\n    models {\n      key\n      source\n      __typename\n    }\n    template\n    __typename\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSTravelerChildrenFragment on EGDSTraveler {\n    count {\n      ...EGDSTravelerStepInputFragment\n    }\n    ... on EGDSTravelerChildren {\n      ages {\n        ...EGDSTravelerChildAgeSelectFragment\n      }\n      ageTemplate {\n        ...EGDSTravelerChildAgeSelectFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSTravelersFragment on EGDSTravelers {\n    adults {\n      ...EGDSTravelerStepInputFragment\n    }\n    children {\n      ...EGDSTravelerChildrenFragment\n    }\n    pets {\n      ...EGDSBasicCheckBoxFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSBasicTravelerSelectorFragment on EGDSBasicTravelerSelector {\n    doneButton {\n      ...EGDSPrimaryButtonFragment\n    }\n    title\n    travelers {\n      ...EGDSTravelersFragment\n    }\n    subTitles\n    validations {\n      ... on EGDSTravelersInputValidation {\n        errorMessage\n        maxCount\n        type\n        errorSummary {\n          ...EGDSErrorSummaryFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSSearchFormTravelersFieldFragment on EGDSSearchFormTravelersField {\n    action {\n      ... on EGDSOpenTravelerSelectorAction {\n        analytics {\n          linkName\n          referrerId\n        }\n        travelerSelector {\n          ...EGDSBasicTravelerSelectorFragment\n        }\n      }\n    }\n    egdsElementIdTravelerSelector: egdsElementId\n    travelerLabel: label\n    labelTemplate {\n      ... on EGDSCardinalLocalizedText {\n        models {\n          key\n          source\n        }\n        templates {\n          category\n          template\n        }\n        secondaryTemplates {\n          category\n          template\n        }\n        text\n      }\n      ... on EGDSCompositeLocalizedText {\n        models {\n          key\n          models {\n            ... on EGDSCardinalLocalizedText {\n              models {\n                key\n                source\n              }\n              templates {\n                category\n                template\n              }\n            }\n          }\n        }\n        template\n        text\n      }\n    }\n    leftIcon {\n      id\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSInputSinglSelectFragment on EGDSBasicSelect {\n    __typename\n    disabled\n    egdsElementId\n    label\n    options {\n      value\n      label\n      selected\n    }\n    value\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _taggedTemplateLiteral([
        "\n  fragment InquiryPhoneInputFieldFragment on InquiryPhoneInputField {\n    __typename\n    countryCode {\n      ...EGDSInputSinglSelectFragment\n    }\n    phoneNumber {\n      ...EGDSInputTextFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _taggedTemplateLiteral([
        "\n  fragment InquiryFormFieldFragment on InquiryFormInputElement {\n    __typename\n    ...EGDSInputTextFragment\n    ...EGDSBasicCheckBoxFragment\n    ...InquiryFormTextAreaFragment\n    ...EGDSSearchFormTravelersFieldFragment\n    ...InquiryPhoneInputFieldFragment\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _taggedTemplateLiteral([
        "\n  fragment InquiryFormFragment on InquiryFormLayout {\n    header\n    analytics {\n      referrerId\n      linkName\n    }\n    datePicker {\n      ...InquiryFormDateRangePickerFragment\n    }\n    formInput {\n      ...InquiryFormFieldFragment\n    }\n    ...InquiryFormDisclaimerFragment\n    submitButton {\n      ...InquiryFormButtonFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _taggedTemplateLiteral([
        "\n  mutation InquiryFormMutation($context: ContextInput!, $inquiryRequestInput: InquiryRequestInput!) {\n    submitInquiry(context: $context, inquiryRequest: $inquiryRequestInput) {\n      ...ConfirmationScreenFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ContactHostInquiryFormDialogFragment on InquiryFormDialogAction {\n    inquiryFormModal {\n      ...InquiryFormFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ContactHostButtonFragment on ContactHostButton {\n    button {\n      __typename\n      ... on UISecondaryButton {\n        analytics {\n          ...buttonAnalytics\n        }\n        disabled\n        primary\n      }\n      ... on UITertiaryButton {\n        analytics {\n          ...buttonAnalytics\n        }\n        disabled\n        primary\n      }\n    }\n    action {\n      ... on UILinkAction {\n        analytics {\n          referrerId\n          linkName\n        }\n        resource {\n          value\n        }\n        target\n        useRelativePath\n      }\n      ...ContactHostInquiryFormDialogFragment\n    }\n  }\n  fragment buttonAnalytics on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n    uisPrimeMessages {\n      messageContent\n      schemaName\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ContactHostSectionFragment on ContactHostSection {\n    header\n    cta {\n      ...ContactHostButtonFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _taggedTemplateLiteral([
        "\n  query ContactHostQuery($context: ContextInput!, $prominence: InquiryProminence, $inquiryFormInput: InquiryFormInput) {\n    contactHost(context: $context, prominence: $prominence, inquiryFormInput: $inquiryFormInput) {\n      ...ContactHostSectionFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
import React40 from "react";
import { gql as gql38, useQuery } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
// src/components/contact-host/__private/__fragments/contact-host-context.tsx
import React, { createContext, useContext, useState } from "react";
var ContactHostContext = createContext(null);
var ContactHostContextProvider = function(param) {
    var children = param.children;
    var _useState = _slicedToArray(useState([]), 2), propertyIds = _useState[0], setPropertyIds = _useState[1];
    var _useState1 = _slicedToArray(useState("centered"), 2), sheetViewType = _useState1[0], setSheetViewType = _useState1[1];
    var _useState2 = _slicedToArray(useState(false), 2), isInquiryRoute = _useState2[0], setIsInquiryRoute = _useState2[1];
    var _useState3 = _slicedToArray(useState(void 0), 2), inquiryUpdatedFields = _useState3[0], setInquiryUpdatedFields = _useState3[1];
    var value = {
        propertyIds: propertyIds,
        sheetViewType: sheetViewType,
        isInquiryRoute: isInquiryRoute,
        inquiryUpdatedFields: inquiryUpdatedFields,
        setPropertyIds: setPropertyIds,
        setSheetViewType: setSheetViewType,
        setIsInquiryRoute: setIsInquiryRoute,
        setInquiryUpdatedFields: setInquiryUpdatedFields
    };
    return /* @__PURE__ */ React.createElement(ContactHostContext.Provider, {
        value: value
    }, children);
};
var useContactHostContext = function() {
    var context = useContext(ContactHostContext);
    if (!context) {
        throw new Error("useContactHostContext can only be used inside ContactHostContextProvider");
    }
    return context;
};
// src/components/contact-host/__private/__fragments/contact-host-section.tsx
import React39 from "react";
import { gql as gql37 } from "@apollo/client";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutGrid, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading5 } from "uitk-react-text";
// src/components/contact-host/__private/__fragments/contact-host-button.tsx
import React38, { useEffect as useEffect4, useRef as useRef2, useState as useState4 } from "react";
import { useLocation } from "react-router-dom";
import { gql as gql36 } from "@apollo/client";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
import { UitkSecondaryButton, UitkTertiaryButton } from "uitk-react-button";
// src/components/contact-host/__private/__fragments/contact-host-inquiry-form-dialog.tsx
import React37, { useEffect as useEffect3, useRef } from "react";
import { gql as gql35 } from "@apollo/client";
import { useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
import { UitkSheet as UitkSheet2, UitkSheetContent } from "uitk-react-sheet";
import { UitkToolbar as UitkToolbar2 } from "uitk-react-toolbar";
// src/utils/eg-clickstream-helpers.tsx
var IMPRESSION = "Impression";
var SCHEMA_NAME = "event";
var buildEvent = function(schemaName, eventName, eventType, eventVersion) {
    return {
        event: {
            schema_name: schemaName,
            event_name: eventName,
            event_type: eventType,
            event_version: eventVersion
        }
    };
};
var inquiryFormViewedEvent = function() {
    return buildEvent(SCHEMA_NAME, "ContactHostInquiryFormViewed", IMPRESSION, "1.0.0" /* ONE_ZERO_ZERO */ );
};
// src/components/contact-host/__private/__fragments/controls/traveler-selector/travelers-basic-provider.tsx
import React2 from "react";
var noAgeSelected = function(childrenAge) {
    return childrenAge.__typename === "EGDSTravelerChildAgeSelect" && childrenAge.value === null;
};
var _children_ages_filter_length;
var getChildCountWithoutAge = function(children) {
    return (_children_ages_filter_length = children === null || children === void 0 ? void 0 : children.ages.filter(noAgeSelected).length) !== null && _children_ages_filter_length !== void 0 ? _children_ages_filter_length : 0;
};
var getTravelersError = function(currentError, travelers, validations) {
    var _travelers_children, _travelers_children1;
    var _travelers_children_count_value;
    var childrenCount = (_travelers_children_count_value = (_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : _travelers_children.count.value) !== null && _travelers_children_count_value !== void 0 ? _travelers_children_count_value : 0;
    var _travelers_adults_value;
    var adultCount = (_travelers_adults_value = travelers.adults.value) !== null && _travelers_adults_value !== void 0 ? _travelers_adults_value : 0;
    var travelersCount = adultCount + childrenCount;
    var kidsWithoutAgeCount = ((_travelers_children1 = travelers.children) === null || _travelers_children1 === void 0 ? void 0 : _travelers_children1.__typename) === "EGDSTravelerChildren" ? getChildCountWithoutAge(travelers.children) : 0;
    var errors = validations.map(function(validation) {
        if (validation.__typename === "EGDSTravelersInputValidation") {
            var type = validation.type, message = validation.errorMessage, maxCount = validation.maxCount, errorSummary = validation.errorSummary;
            var _obj;
            var validationErrors = (_obj = {}, _defineProperty(_obj, "MAX_TRAVELERS" /* MAX_TRAVELERS */ , maxCount ? travelersCount > maxCount && {
                message: message,
                type: type,
                displayConfirmation: true,
                errorCount: 1,
                errorSummary: errorSummary
            } : null), _defineProperty(_obj, "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ , kidsWithoutAgeCount > 0 ? {
                message: message,
                type: type,
                displayConfirmation: false,
                errorCount: kidsWithoutAgeCount,
                errorSummary: errorSummary
            } : null), _obj);
            return validationErrors[type];
        }
        return null;
    }).filter(function(error) {
        return !!error;
    });
    var sameErrorPresent = errors.find(function(error) {
        return currentError && currentError.type === (error === null || error === void 0 ? void 0 : error.type);
    });
    if (sameErrorPresent && (currentError === null || currentError === void 0 ? void 0 : currentError.displayConfirmation)) {
        return _objectSpreadProps(_objectSpread({}, currentError), {
            errorCount: currentError.type === "MAX_TRAVELERS" /* MAX_TRAVELERS */  ? 1 : kidsWithoutAgeCount
        });
    }
    return errors ? errors[0] : null;
};
var getUpdatedTravelersCount = function(travelers, action) {
    switch(action.travelersType){
        case "adults" /* ADULTS */ :
            {
                return _objectSpreadProps(_objectSpread({}, travelers), {
                    adults: _objectSpreadProps(_objectSpread({}, travelers.adults), {
                        value: action.count
                    })
                });
            }
        case "children" /* CHILDREN */ :
            {
                var _travelers_children;
                if (((_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : _travelers_children.__typename) === "EGDSTravelerChildren") {
                    var _children_ages, _children_ages1;
                    var children = travelers.children;
                    var childrenAdded = action.count > children.count.value;
                    var ages = childrenAdded ? (_children_ages = children.ages) === null || _children_ages === void 0 ? void 0 : _children_ages.concat(children.ageTemplate) : (_children_ages1 = children.ages) === null || _children_ages1 === void 0 ? void 0 : _children_ages1.slice(0, -1);
                    var newChildren = _objectSpreadProps(_objectSpread({}, children), {
                        count: _objectSpreadProps(_objectSpread({}, children.count), {
                            value: action.count
                        }),
                        ages: ages
                    });
                    return _objectSpreadProps(_objectSpread({}, travelers), {
                        children: newChildren
                    });
                }
                return travelers;
            }
        default:
            return travelers;
    }
};
var getUpdatedChildAge = function(travelers, action) {
    var _travelers_children;
    if (((_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : _travelers_children.__typename) === "EGDSTravelerChildren") {
        return _objectSpreadProps(_objectSpread({}, travelers), {
            children: _objectSpreadProps(_objectSpread({}, travelers.children), {
                ages: travelers.children.ages.map(function(child, ageIndex) {
                    return child.__typename === "EGDSTravelerChildAgeSelect" && action.childIndex === ageIndex ? _objectSpreadProps(_objectSpread({}, child), {
                        value: action.childAge
                    }) : _objectSpread({}, child);
                })
            })
        });
    }
    return travelers;
};
var getUpdatedPetsFilter = function(travelers, action) {
    var _travelers_pets;
    if (((_travelers_pets = travelers.pets) === null || _travelers_pets === void 0 ? void 0 : _travelers_pets.__typename) === "EGDSBasicCheckBox") {
        var state = action.checked ? "CHECKED" /* CHECKED */  : "UNCHECKED" /* UNCHECKED */ ;
        return _objectSpreadProps(_objectSpread({}, travelers), {
            pets: _objectSpreadProps(_objectSpread({}, travelers.pets), {
                state: state
            })
        });
    }
    return travelers;
};
var travelersReducer = function(state, action) {
    switch(action.type){
        case "RESET_STATE":
            {
                return action.state;
            }
        case "UPDATE_TRAVELERS_COUNT":
            {
                var travelers = getUpdatedTravelersCount(state.travelers, action);
                var _state_validations;
                var error = getTravelersError(state.error ? state.error : null, travelers, (_state_validations = state.validations) !== null && _state_validations !== void 0 ? _state_validations : []);
                return _objectSpreadProps(_objectSpread({}, state), {
                    travelers: travelers,
                    error: error
                });
            }
        case "UPDATE_CHILD_AGE":
            {
                var travelers1 = getUpdatedChildAge(state.travelers, action);
                var _state_validations1;
                var error1 = getTravelersError(state.error ? state.error : null, travelers1, (_state_validations1 = state.validations) !== null && _state_validations1 !== void 0 ? _state_validations1 : []);
                return _objectSpreadProps(_objectSpread({}, state), {
                    travelers: travelers1,
                    error: error1
                });
            }
        case "UPDATE_PETS_FILTER":
            {
                var travelers2 = getUpdatedPetsFilter(state.travelers, action);
                var _state_validations2;
                var error2 = getTravelersError(state.error ? state.error : null, travelers2, (_state_validations2 = state.validations) !== null && _state_validations2 !== void 0 ? _state_validations2 : []);
                return _objectSpreadProps(_objectSpread({}, state), {
                    travelers: travelers2,
                    error: error2
                });
            }
        case "SHOW_ERROR":
            {
                if (state.error) {
                    var _state_error = state.error, message = _state_error.message, type = _state_error.type, errorCount = _state_error.errorCount, errorSummary = _state_error.errorSummary;
                    var newError = {
                        message: message,
                        type: type,
                        displayConfirmation: true,
                        errorCount: errorCount,
                        errorSummary: errorSummary
                    };
                    return _objectSpreadProps(_objectSpread({}, state), {
                        error: newError
                    });
                }
                return _objectSpread({}, state);
            }
        default:
            return state;
    }
};
var TravelersContext = React2.createContext({
    state: {}
});
var BasicTravelersProvider = function(param) {
    var children = param.children, travelers = param.travelers, validations = param.validations;
    var _React2_useReducer = _slicedToArray(React2.useReducer(travelersReducer, {
        travelers: travelers,
        validations: validations
    }), 2), state = _React2_useReducer[0], dispatch = _React2_useReducer[1];
    var travelersContext = {
        state: state,
        dispatch: dispatch
    };
    return /* @__PURE__ */ React2.createElement(TravelersContext.Provider, {
        value: travelersContext
    }, children);
};
var useBasicTravelersContext = function() {
    return React2.useContext(TravelersContext);
};
// src/components/contact-host/__private/__fragments/inquiry-form/inquiry-form.tsx
import React36 from "react";
import { gql as gql34, useMutation } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { UitkForm as UitkForm2 } from "uitk-react-form";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading4 } from "uitk-react-text";
// src/components/contact-host/__private/__fragments/inquiry-form/utils/inquiry-forms-utils.tsx
var inquiryFormFieldSelector = {
    PHONE_NUMBER: "inquirerPhoneNumber",
    COUNTRY_CODE: "inquirerPhoneCountryCode",
    MESSAGE: "message",
    NEWS_LETTER_SUBSCRIBE: "optInForMarketing",
    PETS_TRAVELERS: "petsAllowed"
};
var clearSpaces = function(text) {
    return text.trim().replace(/\s+/g, " ");
};
function validateAndGetValues(typename, value, existingControlValue) {
    if (existingControlValue !== void 0) {
        var existingValue = String(existingControlValue);
        if (existingValue !== value) {
            return {
                isValueUpdated: true,
                currentValue: String(value)
            };
        }
    }
    return {
        isValueUpdated: false,
        currentValue: String(value)
    };
}
function omitProperty(obj, property) {
    var unused = obj[property], rest = _objectWithoutProperties(obj, [
        property
    ].map(_toPropertyKey));
    return rest;
}
var buildPrimaryPropertyCriteriaPayload = function(formState, propertyIds, travelers) {
    var _travelers_children;
    var requestFieldItems = {};
    Object.values((formState === null || formState === void 0 ? void 0 : formState.formValue) || {}).forEach(function(item) {
        if (item.typename === "EGDSBasicSelect") {
            var _item_options;
            var selectedOption = (_item_options = item.options) === null || _item_options === void 0 ? void 0 : _item_options.find(function(x) {
                return x.label === item.value;
            });
            requestFieldItems[item.id] = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) || "+1";
        } else if (item.typename === "EGDSBasicCheckBox") {
            requestFieldItems[item.id] = item.checked;
        } else {
            requestFieldItems[item.id] = item.value;
        }
    });
    var dateRange = null;
    var datePickerData = formState.datePicker;
    if ((datePickerData === null || datePickerData === void 0 ? void 0 : datePickerData.selectedStartDate) && (datePickerData === null || datePickerData === void 0 ? void 0 : datePickerData.selectedEndDate)) {
        dateRange = {
            checkInDate: omitProperty(datePickerData.selectedStartDate, "__typename"),
            checkOutDate: omitProperty(datePickerData.selectedEndDate, "__typename")
        };
    }
    var children = [];
    if ((travelers === null || travelers === void 0 ? void 0 : (_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : _travelers_children.__typename) === "EGDSTravelerChildren") {
        var _travelers_children1;
        var childAges = (_travelers_children1 = travelers.children) === null || _travelers_children1 === void 0 ? void 0 : _travelers_children1.ages;
        children = childAges === null || childAges === void 0 ? void 0 : childAges.reduce(function(acc, item) {
            return item.value || item.value === 0 ? _toConsumableArray(acc).concat([
                {
                    age: item.value
                }
            ]) : acc;
        }, []);
    }
    var rooms = [
        {
            adults: travelers.adults.value,
            children: children
        }
    ];
    var primaryPropertyCriteriaInput = {
        rooms: rooms,
        destination: {
            propertyIds: propertyIds
        },
        dateRange: dateRange
    };
    return _objectSpreadProps(_objectSpread({}, requestFieldItems), {
        message: requestFieldItems.message.toString(),
        primaryPropertyCriteriaInput: primaryPropertyCriteriaInput
    });
};
// src/components/contact-host/__private/__fragments/controls/confirmation-screen.tsx
import React3, { useEffect } from "react";
import { gql } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkButtonSize, UitkPrimaryButton } from "uitk-react-button";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading, UitkText } from "uitk-react-text";
var __Fragment = gql(_templateObject());
var ConfirmationScreen = function(param) {
    var data = param.data, onDialogClose = param.onDialogClose;
    var body = data.body, header = data.header, doneButton = data.doneButton, analytics = data.analytics;
    var track = useClickTracker();
    var RenderHeader = React3.memo(function() {
        return /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React3.createElement("div", {
            "data-stid": "done-icon"
        }, /* @__PURE__ */ React3.createElement(UitkIcon, {
            name: "done",
            size: UitkIconSize.MEDIUM,
            theme: "positive",
            spotlight: "standard"
        }))), /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React3.createElement(UitkSpacing, null, /* @__PURE__ */ React3.createElement(UitkHeading, {
            size: 6
        }, header))));
    });
    RenderHeader.displayName = "RenderHeader";
    var handleClick = function() {
        if (doneButton === null || doneButton === void 0 ? void 0 : doneButton.analytics) {
            var _doneButton_analytics = doneButton.analytics, referrerId = _doneButton_analytics.referrerId, linkName = _doneButton_analytics.linkName;
            track(referrerId, linkName);
        }
        onDialogClose();
    };
    useEffect(function() {
        if (analytics) {
            track(analytics.referrerId, analytics.linkName);
        }
    }, []);
    return /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React3.createElement(UitkSpacing, null, /* @__PURE__ */ React3.createElement(Viewport, null, /* @__PURE__ */ React3.createElement(ViewMedium, null, /* @__PURE__ */ React3.createElement(UitkLayoutFlex, {
        space: "two",
        alignItems: "center",
        justifyContent: "center"
    }, /* @__PURE__ */ React3.createElement(RenderHeader, null))), /* @__PURE__ */ React3.createElement(ViewSmall, null, /* @__PURE__ */ React3.createElement(UitkLayoutFlex, {
        space: "two",
        alignItems: "center",
        justifyContent: "start"
    }, /* @__PURE__ */ React3.createElement(RenderHeader, null)))))), /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React3.createElement(UitkSpacing, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlex, {
        justifyContent: "center"
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem, {
        maxWidth: "180x"
    }, /* @__PURE__ */ React3.createElement("div", null, body === null || body === void 0 ? void 0 : body.map(function(element, index) {
        return /* @__PURE__ */ React3.createElement(UitkSpacing, {
            margin: "two",
            key: index
        }, /* @__PURE__ */ React3.createElement(Viewport, null, /* @__PURE__ */ React3.createElement(ViewMedium, null, /* @__PURE__ */ React3.createElement(UitkText, {
            size: 300
        }, element)), /* @__PURE__ */ React3.createElement(ViewSmall, null, /* @__PURE__ */ React3.createElement(UitkText, {
            size: 200
        }, element))));
    })))))), doneButton && /* @__PURE__ */ React3.createElement(UitkSpacing, {
        padding: "six"
    }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(UitkLayoutFlex, {
        alignItems: "center",
        justifyContent: "center"
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem, {
        alignSelf: "center",
        maxWidth: "quarter_width"
    }, /* @__PURE__ */ React3.createElement(UitkPrimaryButton, {
        "data-stid": "contact-host-done-button",
        "aria-label": doneButton.accessibility || "",
        onClick: handleClick,
        isFullWidth: true,
        size: UitkButtonSize.LARGE
    }, doneButton.primary))))));
};
ConfirmationScreen.displayName = "ConfirmationScreen";
ConfirmationScreen.fragment = __Fragment;
// src/components/contact-host/__private/__fragments/controls/inquiry-form-button.tsx
import React4 from "react";
import { gql as gql2 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize as UitkButtonSize2, UitkPrimaryButton as UitkPrimaryButton2 } from "uitk-react-button";
import { UitkLoader } from "uitk-react-loader";
var __Fragment2 = gql2(_templateObject1());
var InquiryFormButton = function(param) {
    var data = param.data, localDisabled = param.localDisabled, onClick = param.onClick, showLoader = param.showLoader;
    var track = useClickTracker2();
    var primary = data.primary, analytics = data.analytics, accessibility = data.accessibility, disabled = data.disabled;
    if (!primary) {
        return null;
    }
    var handleOnClick = function() {
        if (analytics) {
            track(analytics.referrerId, analytics.linkName);
        }
        onClick();
    };
    return /* @__PURE__ */ React4.createElement(UitkPrimaryButton2, {
        type: "button",
        onClick: handleOnClick,
        disabled: localDisabled || disabled,
        isFullWidth: true,
        size: UitkButtonSize2.LARGE,
        "aria-label": accessibility || ""
    }, showLoader ? /* @__PURE__ */ React4.createElement(UitkLoader, {
        isDarkBackground: true
    }) : data.primary);
};
InquiryFormButton.displayName = "InquiryFormButton";
InquiryFormButton.fragment = __Fragment2;
// src/components/contact-host/__private/__fragments/controls/inquiry-form-date-range-picker.tsx
import React6 from "react";
import { gql as gql3 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkDatePicker, UitkDatePickerRenderType } from "uitk-react-date-picker";
// src/components/contact-host/__private/__fragments/controls/utils/helpers.tsx
import React5 from "react";
import { DayName } from "uitk-react-date-picker";
var convertFromMiliSecondsToDays = function(miliseconds) {
    return Math.ceil(miliseconds / 1e3 / 60 / 60 / 24);
};
var convertToDateObject = function(param) {
    var year = param.year, month = param.month, day = param.day;
    return new Date(year, month - 1, day);
};
var dialogWrapper = function(DialogWrapper) {
    return function(children) {
        return /* @__PURE__ */ React5.createElement(DialogWrapper, null, children);
    };
};
var routerLinkWrapper = function(children) {
    return /* @__PURE__ */ React5.createElement(React5.Fragment, null, children);
};
var _obj;
var EGDSDayNameMap = (_obj = {}, _defineProperty(_obj, "SUN" /* SUN */ , DayName.SUN), _defineProperty(_obj, "MON" /* MON */ , DayName.MON), _defineProperty(_obj, "TUE" /* TUE */ , DayName.TUE), _defineProperty(_obj, "WED" /* WED */ , DayName.WED), _defineProperty(_obj, "THU" /* THU */ , DayName.THU), _defineProperty(_obj, "FRI" /* FRI */ , DayName.FRI), _defineProperty(_obj, "SAT" /* SAT */ , DayName.SAT), _obj);
var parseDate = function(date) {
    return {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    };
};
function formatLocalizedTokenString(localizedString, token, value) {
    return localizedString.replace("${".concat(token, "}"), value);
}
// src/components/contact-host/__private/__fragments/controls/inquiry-form-date-range-picker.tsx
var DISPLAY_NAME = "InquiryFormDateRangePicker";
var START_DATE_NAME_PREFIX = "".concat(DISPLAY_NAME, "-StartDate");
var END_DATE_NAME_PREFIX = "".concat(DISPLAY_NAME, "-EndDate");
var __Fragment3 = gql3(_templateObject2());
var InquiryFormDateRangePicker = function(param) {
    var data = param.data, errorMessage = param.errorMessage, autoOpen = param.autoOpen, onChange = param.onChange;
    var buttonText = data.buttonText, clearButtonText = data.clearButtonText, dateFormat = data.dateFormat, firstDayOfWeek = data.firstDayOfWeek, selectedEndDate = data.selectedEndDate, endDatePlaceholderText = data.endDatePlaceholderText, selectedStartDate = data.selectedStartDate, startDatePlaceholderText = data.startDatePlaceholderText, validDaysLowerBoundInclusive = data.validDaysLowerBoundInclusive, validDaysUpperBoundInclusive = data.validDaysUpperBoundInclusive, sameDaySelectionAllowed = data.sameDaySelectionAllowed, endDateButtonAnalytics = data.endDateButtonAnalytics, startDateButtonAnalytics = data.startDateButtonAnalytics, nextButtonAnalytics = data.nextButtonAnalytics, previousButtonAnalytics = data.previousButtonAnalytics, submitButtonAnalytics = data.submitButtonAnalytics;
    var datePickerDateFormat = "yyyy-MM-dd";
    var formatDateString = useLocalization().formatDateString;
    var _useDialog = _slicedToArray(useDialog("inquiry_form_date_picker_dialog", "pwaDialogNested"), 3), dialogActions = _useDialog[1], DialogWrapper = _useDialog[2];
    var closeDialog = dialogActions.closeDialog, openDialog = dialogActions.openDialog;
    var _React6_useState = _slicedToArray(React6.useState(autoOpen !== null && autoOpen !== void 0 ? autoOpen : false), 2), showDatePicker = _React6_useState[0], setShowDatePicker = _React6_useState[1];
    var _React6_useState1 = _slicedToArray(React6.useState({
        startDate: formatDateString(selectedStartDate ? convertToDateObject(selectedStartDate) : "", {
            raw: datePickerDateFormat
        }),
        endDate: formatDateString(selectedEndDate ? convertToDateObject(selectedEndDate) : "", {
            raw: datePickerDateFormat
        })
    }), 2), dateState = _React6_useState1[0], setDateState = _React6_useState1[1];
    var track = useClickTracker3();
    var _React6_useState2 = _slicedToArray(React6.useState(formatDateString(/* @__PURE__ */ new Date(), {
        raw: datePickerDateFormat
    })), 2), validStartDate = _React6_useState2[0], setValidStartDate = _React6_useState2[1];
    var defaultDaysBookableInAdvance = 500;
    var _React6_useState3 = _slicedToArray(React6.useState(defaultDaysBookableInAdvance), 2), daysBookableInAdvance = _React6_useState3[0], setDaysBookableInAdvance = _React6_useState3[1];
    var startDate = dateState.startDate, endDate = dateState.endDate;
    React6.useEffect(function() {
        var dateFormatOptions = {
            raw: datePickerDateFormat
        };
        setDateState(function(prevState) {
            return _objectSpreadProps(_objectSpread({}, prevState), {
                startDate: formatDateString(selectedStartDate ? convertToDateObject(selectedStartDate) : "", dateFormatOptions),
                endDate: formatDateString(selectedEndDate ? convertToDateObject(selectedEndDate) : "", dateFormatOptions)
            });
        });
        if (validDaysLowerBoundInclusive) {
            setValidStartDate(formatDateString(convertToDateObject(validDaysLowerBoundInclusive), dateFormatOptions));
        }
        if (validDaysUpperBoundInclusive) {
            var difference = convertToDateObject(validDaysUpperBoundInclusive).getTime() - /* @__PURE__ */ new Date().getTime();
            setDaysBookableInAdvance(convertFromMiliSecondsToDays(difference));
        }
    }, [
        formatDateString,
        selectedEndDate,
        selectedStartDate,
        validDaysLowerBoundInclusive,
        validDaysUpperBoundInclusive
    ]);
    var onOpenCB = function(_, isSmallViewportSize) {
        setShowDatePicker(true);
        if (isSmallViewportSize) {
            openDialog();
        }
    };
    var onSubmitCB = function(start, end, isSmallViewportSize) {
        if (isSmallViewportSize) {
            closeDialog();
        } else {
            setShowDatePicker(false);
        }
        if (!start && !end) {
            setDateState({
                startDate: start,
                endDate: end
            });
            onChange(start, end);
            return;
        }
        var newEndDate = end || new Date(start.getFullYear(), start.getMonth(), start.getDate() + 1);
        var startDateStr = formatDateString(start, {
            raw: datePickerDateFormat
        });
        var endDateStr = formatDateString(newEndDate, {
            raw: datePickerDateFormat
        });
        setDateState({
            startDate: startDateStr,
            endDate: endDateStr
        });
        var checkinDate = parseDate(start);
        var checkoutDate = parseDate(newEndDate);
        onChange(checkinDate, checkoutDate);
    };
    var onDismissCB = function(isSmallViewportSize, noUpdate) {
        if (isSmallViewportSize) {
            closeDialog();
        }
        if (!noUpdate) {
            setShowDatePicker(false);
        }
    };
    var setupAnalytics = function(id, description, clickTrack) {
        return {
            id: id,
            description: description,
            callback: function() {
                return clickTrack(id, description, true);
            }
        };
    };
    var datePickerAnalytics;
    if (submitButtonAnalytics) {
        var referrerId = submitButtonAnalytics.referrerId, linkName = submitButtonAnalytics.linkName;
        datePickerAnalytics = {
            doneAnalytics: referrerId && linkName && setupAnalytics(referrerId, linkName, track)
        };
    }
    var dateFieldProps = {
        endAnalytics: (endDateButtonAnalytics === null || endDateButtonAnalytics === void 0 ? void 0 : endDateButtonAnalytics.linkName) && (endDateButtonAnalytics === null || endDateButtonAnalytics === void 0 ? void 0 : endDateButtonAnalytics.referrerId) && setupAnalytics(endDateButtonAnalytics.referrerId, endDateButtonAnalytics.linkName, track),
        endId: "end-id",
        endInvalid: "",
        endLabel: endDatePlaceholderText,
        endName: END_DATE_NAME_PREFIX,
        endPlaceholder: endDatePlaceholderText,
        routerLinkWrapper: routerLinkWrapper,
        dateFormat: dateFormat,
        showDatePicker: showDatePicker,
        startAnalytics: (startDateButtonAnalytics === null || startDateButtonAnalytics === void 0 ? void 0 : startDateButtonAnalytics.linkName) && (startDateButtonAnalytics === null || startDateButtonAnalytics === void 0 ? void 0 : startDateButtonAnalytics.referrerId) && setupAnalytics(startDateButtonAnalytics === null || startDateButtonAnalytics === void 0 ? void 0 : startDateButtonAnalytics.referrerId, startDateButtonAnalytics === null || startDateButtonAnalytics === void 0 ? void 0 : startDateButtonAnalytics.linkName, track),
        startId: "start-id",
        startInvalid: errorMessage,
        startLabel: startDatePlaceholderText,
        startName: START_DATE_NAME_PREFIX,
        startPlaceholder: startDatePlaceholderText
    };
    var datePickerProps = {
        analytics: datePickerAnalytics,
        buttonText: buttonText,
        dateFieldProps: dateFieldProps,
        daysBookableInAdvance: daysBookableInAdvance,
        dialogWrapper: dialogWrapper(DialogWrapper),
        endDate: endDate,
        firstDayOfWeek: EGDSDayNameMap[firstDayOfWeek],
        onDismissCB: onDismissCB,
        onOpenCB: onOpenCB,
        onSubmitCB: onSubmitCB,
        startDate: startDate,
        validStartDate: validStartDate,
        useClearDates: true,
        clearButtonText: clearButtonText !== null && clearButtonText !== void 0 ? clearButtonText : void 0,
        singleDateSelect: sameDaySelectionAllowed,
        renderType: UitkDatePickerRenderType.DIALOG
    };
    return /* @__PURE__ */ React6.createElement(UitkDatePicker, _objectSpread({}, datePickerProps));
};
InquiryFormDateRangePicker.displayName = "InquiryFormDateRangePicker";
InquiryFormDateRangePicker.fragment = __Fragment3;
// src/components/contact-host/__private/__fragments/controls/inquiry-form-disclaimer.tsx
import React16 from "react";
import { gql as gql13 } from "@apollo/client";
// ../internal/src/components/lodging-egds-text/lodging-egds-text.tsx
import React10 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkText as UitkText3 } from "uitk-react-text";
// ../internal/src/components/lodging-egds-text/lodging-egds-inline-link.tsx
import React7 from "react";
import { gql as gql4 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
var _obj1;
// ../internal/src/components/__private/link-map.ts
var linkSizeMapper = (_obj1 = {}, _defineProperty(_obj1, "SMALL" /* SMALL */ , "small"), _defineProperty(_obj1, "MEDIUM" /* MEDIUM */ , "medium"), _defineProperty(_obj1, "LARGE" /* LARGE */ , "large"), _obj1);
var _obj2;
var UILinkTargetMap = (_obj2 = {}, _defineProperty(_obj2, "EXTERNAL" /* EXTERNAL */ , "_blank"), _defineProperty(_obj2, "INTERNAL" /* INTERNAL */ , "_self"), _obj2);
// ../internal/src/components/lodging-egds-text/lodging-egds-inline-link.tsx
var fragment = gql4(_templateObject3());
var LodgingEGDSInlineLink = function(param) {
    var className = param.className, _param_data = param.data, _param_data_action = _param_data.action, analytics = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, accessibility = _param_data_action.accessibility, disabled = _param_data.disabled, linkSize = _param_data.linkSize, text = _param_data.text;
    var clickTracker = useClickTracker4();
    var onClick = React7.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    return /* @__PURE__ */ React7.createElement(UitkLink, {
        className: className,
        size: linkSizeMapper[linkSize],
        onClickCapture: onClick,
        disabled: disabled,
        inline: true
    }, /* @__PURE__ */ React7.createElement("a", {
        href: resource.value,
        target: UILinkTargetMap[target]
    }, text, accessibility && /* @__PURE__ */ React7.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility)));
};
LodgingEGDSInlineLink.fragment = fragment;
LodgingEGDSInlineLink.displayName = "LodgingEGDSInlineLink";
// ../internal/src/components/lodging-egds-text/lodging-egds-paragraph.tsx
import React8 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkParagraph } from "uitk-react-text";
var fragment2 = gql5(_templateObject4());
var LodgingEGDSParagraph = function(param) {
    var data = param.data, _param_size = param.size, size = _param_size === void 0 ? 2 : _param_size;
    return /* @__PURE__ */ React8.createElement(UitkParagraph, {
        size: size
    }, data.text);
};
LodgingEGDSParagraph.fragment = fragment2;
LodgingEGDSParagraph.displayName = "LodgingEGDSParagraph";
// ../internal/src/components/lodging-egds-text/lodging-egds-stylized-text.tsx
import React9 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkText as UitkText2 } from "uitk-react-text";
var _obj3;
// ../internal/src/components/lodging-egds-text/__private/text-theme.ts
var textThemeMapper = (_obj3 = {}, _defineProperty(_obj3, "LOYALTY" /* LOYALTY */ , "loyalty"), _defineProperty(_obj3, "NEGATIVE" /* NEGATIVE */ , "negative"), _defineProperty(_obj3, "POSITIVE" /* POSITIVE */ , "positive"), _defineProperty(_obj3, "PRIMARY" /* PRIMARY */ , "emphasis"), _defineProperty(_obj3, "SECONDARY" /* SECONDARY */ , "default"), _defineProperty(_obj3, "INVERSE" /* INVERSE */ , "inverse"), _obj3);
var _obj4;
// ../internal/src/components/lodging-egds-text/__private/text-weight.ts
var textWeightMapper = (_obj4 = {}, _defineProperty(_obj4, "BOLD" /* BOLD */ , "bold"), _defineProperty(_obj4, "MEDIUM" /* MEDIUM */ , "medium"), _defineProperty(_obj4, "REGULAR" /* REGULAR */ , "regular"), _obj4);
// ../internal/src/components/lodging-egds-text/lodging-egds-stylized-text.tsx
var fragment3 = gql6(_templateObject5());
var sizeMap = {
    "100": 100,
    "200": 200,
    "300": 300,
    "400": 400,
    "500": 500,
    "600": 600,
    "700": 700,
    "800": 800,
    "900": 900
};
var decorativeMap = {
    LINE_THROUGH: "s",
    SUBSCRIPT: "sub",
    SUPERSCRIPT: "sup",
    UNDERLINE: "u"
};
var EGDSStylizedText = function(_param) {
    var data = _param.data, props = _objectWithoutProperties(_param, [
        "data"
    ]);
    var theme = data.theme, weight = data.weight, size = data.size, decorative = data.decorative, accessibility = data.accessibility;
    var overflow = props.overflow, spacing = props.spacing, align = props.align, inline = props.inline;
    var textPropsSize = size || props.size;
    var textProps = {
        theme: theme ? textThemeMapper[theme] : void 0,
        weight: weight ? textWeightMapper[weight] : void 0,
        size: textPropsSize ? sizeMap[textPropsSize] : void 0,
        overflow: overflow,
        spacing: spacing,
        align: align,
        inline: inline
    };
    var Decorative = decorative && decorativeMap[decorative];
    var Accessibility = accessibility && /* @__PURE__ */ React9.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility);
    var content = Decorative ? /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement(Decorative, null, data.text), Accessibility) : /* @__PURE__ */ React9.createElement(React9.Fragment, null, data.text, Accessibility);
    return /* @__PURE__ */ React9.createElement(UitkText2, _objectSpread({}, textProps), content);
};
EGDSStylizedText.fragment = fragment3;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/lodging-egds-text/lodging-egds-text.tsx
var fragment4 = gql7(_templateObject6(), LodgingEGDSParagraph.fragment, EGDSStylizedText.fragment, LodgingEGDSInlineLink.fragment);
var LodgingEGDSText = function(param) {
    var size = param.size, overflow = param.overflow, spacing = param.spacing, data = param.data, align = param.align, inline = param.inline, className = param.className;
    switch(data.__typename){
        case "EGDSPlainText":
            return /* @__PURE__ */ React10.createElement(UitkText3, {
                inline: inline,
                size: size
            }, data.text);
        case "EGDSParagraph":
            return /* @__PURE__ */ React10.createElement(LodgingEGDSParagraph, {
                data: data
            });
        case "EGDSStylizedText":
            return /* @__PURE__ */ React10.createElement(EGDSStylizedText, {
                size: size,
                overflow: overflow,
                spacing: spacing,
                data: data,
                align: align,
                inline: inline
            });
        case "EGDSInlineLink":
            return /* @__PURE__ */ React10.createElement(LodgingEGDSInlineLink, {
                className: className,
                data: data
            });
        default:
            return null;
    }
};
LodgingEGDSText.fragment = fragment4;
LodgingEGDSText.displayName = "LodgingEGDSText";
// ../internal/src/components/lodging-egds-text/lodging-egds-heading.tsx
import React11 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
var fragment5 = gql8(_templateObject7());
var LodgingEGDSHeading = function(param) {
    var tag = param.tag, size = param.size, data = param.data;
    return /* @__PURE__ */ React11.createElement(UitkHeading2, {
        tag: tag,
        size: size
    }, data.text);
};
LodgingEGDSHeading.fragment = fragment5;
LodgingEGDSHeading.displayName = "LodgingEGDSHeading";
// ../internal/src/components/lodging-egds-text/egds-spannable-text.tsx
import React14 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkText as UitkText5 } from "uitk-react-text";
// ../internal/src/components/lodging-egds-text/egds-spannable-text-content.tsx
import React13 from "react";
import { gql as gql10 } from "@apollo/client";
// ../internal/src/components/lodging-egds-text/lodging-egds-plain-text.tsx
import React12 from "react";
import { gql as gql9 } from "@apollo/client";
import { UitkText as UitkText4 } from "uitk-react-text";
var fragment6 = gql9(_templateObject8());
var EGDSPlainText = function(param) {
    var className = param.className, inline = param.inline, size = param.size, align = param.align, data = param.data;
    var text = data.text;
    return /* @__PURE__ */ React12.createElement(UitkText4, {
        className: className,
        inline: inline,
        size: size,
        align: align
    }, text);
};
EGDSPlainText.fragment = fragment6;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/lodging-egds-text/egds-spannable-text-content.tsx
var fragment7 = gql10(_templateObject9(), EGDSStylizedText.fragment, EGDSPlainText.fragment);
var EGDSSpannableTextContent = function(param) {
    var className = param.className, size = param.size, data = param.data;
    switch(data.__typename){
        case "EGDSStylizedText":
            return /* @__PURE__ */ React13.createElement(EGDSStylizedText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React13.createElement(EGDSPlainText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        default:
            return null;
    }
};
EGDSSpannableTextContent.fragment = fragment7;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/lodging-egds-text/egds-spannable-text.tsx
var fragment8 = gql11(_templateObject10(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function(props) {
    var _data_inlineContent, _data_inlineContent1;
    var align = props.align, data = props.data, styleProps = _objectWithoutProperties(props, [
        "align",
        "data"
    ]);
    if (data.contents.length === 0 && !((_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length)) {
        return /* @__PURE__ */ React14.createElement(UitkText5, _objectSpreadProps(_objectSpread({}, styleProps), {
            inline: true,
            align: align
        }), data.text);
    }
    if ((_data_inlineContent1 = data.inlineContent) === null || _data_inlineContent1 === void 0 ? void 0 : _data_inlineContent1.length) {
        return /* @__PURE__ */ React14.createElement(React14.Fragment, null, data.inlineContent.map(function(item, index) {
            return /* @__PURE__ */ React14.createElement(React14.Fragment, null, /* @__PURE__ */ React14.createElement(EGDSSpannableTextContent, _objectSpreadProps(_objectSpread({
                data: item
            }, styleProps), {
                key: "spannable-item-".concat(index)
            })));
        }));
    }
    return /* @__PURE__ */ React14.createElement(React14.Fragment, null, data.contents.map(function(item, index) {
        return /* @__PURE__ */ React14.createElement(React14.Fragment, {
            key: "spannable-item-".concat(index)
        }, /* @__PURE__ */ React14.createElement(EGDSSpannableTextContent, _objectSpread({
            data: item
        }, styleProps)));
    }));
};
EGDSSpannableText.fragment = fragment8;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/lodging-egds-text/lodging-egds-localized-text-template.tsx
import React15 from "react";
import { gql as gql12 } from "@apollo/client";
var fragment9 = gql12(_templateObject11());
var LodgingEGDSLocalizedTextTemplate = function(param) {
    var data = param.data, value = param.value;
    return /* @__PURE__ */ React15.createElement(React15.Fragment, null, data.template.replace("{".concat(data.token, "}"), value));
};
LodgingEGDSLocalizedTextTemplate.fragment = fragment9;
LodgingEGDSLocalizedTextTemplate.displayName = "LodgingEGDSLocalizedTextTemplate";
// src/components/contact-host/__private/__fragments/controls/inquiry-form-disclaimer.tsx
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
var __InquiryFormDisclaimerFragment = gql13(_templateObject12(), LodgingEGDSText.fragment);
var InquiryFormDisclaimer = function(param) {
    var data = param.data;
    var disclaimer = data.disclaimer;
    if (!disclaimer || disclaimer.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React16.createElement(UitkSpacing2, {
        margin: {
            block: "four"
        }
    }, /* @__PURE__ */ React16.createElement("div", null, disclaimer.map(function(element, index) {
        return /* @__PURE__ */ React16.createElement("span", {
            key: index
        }, /* @__PURE__ */ React16.createElement(LodgingEGDSText, {
            key: element.__typename,
            data: element,
            inline: true
        }));
    })));
};
InquiryFormDisclaimer.fragment = __InquiryFormDisclaimerFragment;
InquiryFormDisclaimer.displayName = "InquiryFormDisclaimer";
// src/components/contact-host/__private/__fragments/inquiry-form/context/inquiry-form-context.tsx
import React17, { useCallback, useState as useState2 } from "react";
// src/components/contact-host/__private/__fragments/validation/egds-input-validation.tsx
import { gql as gql18 } from "@apollo/client";
// src/components/contact-host/__private/__fragments/validation/egds-max-length-input-validation.tsx
import { gql as gql14 } from "@apollo/client";
var fragment10 = gql14(_templateObject13());
var defaultValidator = function(value, validation) {
    if (value && value.length > validation.maxLength) {
        return {
            invalid: validation.errorMessage
        };
    }
    return {};
};
var EGDSMaxLengthInputValidation = function(validation) {
    return function(value) {
        return defaultValidator(value, validation);
    };
};
EGDSMaxLengthInputValidation.fragment = fragment10;
// src/components/contact-host/__private/__fragments/validation/egds-min-length-input-validation.tsx
import { gql as gql15 } from "@apollo/client";
var fragment11 = gql15(_templateObject14());
var defaultValidator2 = function(value, validation) {
    if (value && value.length < validation.minLength) {
        return {
            invalid: validation.errorMessage
        };
    }
    return {};
};
var EGDSMinLengthInputValidation = function(validation) {
    return function(value) {
        return defaultValidator2(value, validation);
    };
};
EGDSMinLengthInputValidation.fragment = fragment11;
// src/components/contact-host/__private/__fragments/validation/egds-regex-input-validation.tsx
import { gql as gql16 } from "@apollo/client";
var fragment12 = gql16(_templateObject15());
var defaultValidator3 = function(value, validation) {
    var re = new RegExp(validation.pattern);
    if ((value === null || value === void 0 ? void 0 : value.trim()) && !value.match(re)) {
        return {
            invalid: validation.errorMessage
        };
    }
    return {};
};
var EGDSRegexInputValidation = function(validation) {
    return function(value) {
        return defaultValidator3(value, validation);
    };
};
EGDSRegexInputValidation.fragment = fragment12;
// src/components/contact-host/__private/__fragments/validation/egds-required-input-validation.tsx
import { gql as gql17 } from "@apollo/client";
var fragment13 = gql17(_templateObject16());
var defaultValidator4 = function(value, validation) {
    if (!value || !(value === null || value === void 0 ? void 0 : value.trim())) {
        return {
            invalid: validation.errorMessage
        };
    }
    return {};
};
var EGDSRequiredInputValidation = function(validation) {
    return function(value) {
        return defaultValidator4(value, validation);
    };
};
EGDSRequiredInputValidation.fragment = fragment13;
// src/components/contact-host/__private/__fragments/validation/egds-input-validation.tsx
var fragment14 = gql18(_templateObject17(), EGDSRegexInputValidation.fragment, EGDSRequiredInputValidation.fragment, EGDSMaxLengthInputValidation.fragment, EGDSMinLengthInputValidation.fragment);
var getValidators = function(validations) {
    return validations.map(function(validation) {
        switch(validation.__typename){
            case "EGDSRegexInputValidation":
                return _objectSpreadProps(_objectSpread({}, validation), {
                    validate: EGDSRegexInputValidation(validation)
                });
            case "EGDSMaxLengthInputValidation":
                return _objectSpreadProps(_objectSpread({}, validation), {
                    validate: EGDSMaxLengthInputValidation(validation)
                });
            case "EGDSMinLengthInputValidation":
                return _objectSpreadProps(_objectSpread({}, validation), {
                    validate: EGDSMinLengthInputValidation(validation)
                });
            case "EGDSRequiredInputValidation":
                return _objectSpreadProps(_objectSpread({}, validation), {
                    validate: EGDSRequiredInputValidation(validation)
                });
            default:
                return {
                    validate: function() {
                        return {};
                    }
                };
        }
    });
};
// src/components/contact-host/__private/__fragments/validation/get-clientside-validations.tsx
var getClientsideValidations = function() {
    var validations = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var validators = validations ? getValidators(validations) : [];
    return {
        actOnServerDefinedValidation: function(value) {
            var primary = {};
            validators.forEach(function(validator) {
                if (!primary.invalid) {
                    primary = validator.validate(value);
                }
            });
            return primary;
        }
    };
};
// src/components/contact-host/__private/__fragments/inquiry-form/context/inquiry-form-context.tsx
var returnInitialStateObject = function(id, typename, value) {
    var validations = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    return {
        id: id,
        typename: typename,
        value: value,
        validations: validations
    };
};
var getFormStateData = function(formData, datePicker) {
    var updatedFormData = formData === null || formData === void 0 ? void 0 : formData.reduce(function(acc, item) {
        var initialFormData = _objectSpread({}, acc);
        if (item.__typename === "EGDSBasicCheckBox") {
            var _item_egdsElementId;
            var egdsElementId = (_item_egdsElementId = item.egdsElementId) !== null && _item_egdsElementId !== void 0 ? _item_egdsElementId : inquiryFormFieldSelector.NEWS_LETTER_SUBSCRIBE;
            initialFormData[egdsElementId] = _objectSpreadProps(_objectSpread({}, returnInitialStateObject(egdsElementId, item.__typename, item.state === "CHECKED")), {
                checked: item.state === "CHECKED"
            });
        } else if (item.__typename === "EGDSSearchFormTravelersField") {
            var _item_action, _item_action1;
            if (((_item_action = item.action) === null || _item_action === void 0 ? void 0 : _item_action.__typename) === "EGDSOpenTravelerSelectorAction" && (item === null || item === void 0 ? void 0 : (_item_action1 = item.action) === null || _item_action1 === void 0 ? void 0 : _item_action1.travelerSelector.__typename) === "EGDSBasicTravelerSelector") {
                var _item_action_travelerSelector_travelers, _item_action_travelerSelector_travelers_pets;
                if (((_item_action_travelerSelector_travelers = item.action.travelerSelector.travelers) === null || _item_action_travelerSelector_travelers === void 0 ? void 0 : (_item_action_travelerSelector_travelers_pets = _item_action_travelerSelector_travelers.pets) === null || _item_action_travelerSelector_travelers_pets === void 0 ? void 0 : _item_action_travelerSelector_travelers_pets.__typename) === "EGDSBasicCheckBox") {
                    var petsAllowed = item.action.travelerSelector.travelers.pets;
                    var _petsAllowed_egdsElementId;
                    var egdsElementId1 = (_petsAllowed_egdsElementId = petsAllowed.egdsElementId) !== null && _petsAllowed_egdsElementId !== void 0 ? _petsAllowed_egdsElementId : inquiryFormFieldSelector.PETS_TRAVELERS;
                    initialFormData[egdsElementId1] = _objectSpreadProps(_objectSpread({}, returnInitialStateObject(egdsElementId1, petsAllowed.__typename, "")), {
                        checked: petsAllowed.state === "CHECKED"
                    });
                }
            }
        } else if (item.__typename === "InquiryPhoneInputField") {
            var _countryCode_options;
            var countryCode = item.countryCode, phoneNumber = item.phoneNumber;
            var _countryCode_egdsElementId;
            var countryCodeEgdsElementId = (_countryCode_egdsElementId = countryCode.egdsElementId) !== null && _countryCode_egdsElementId !== void 0 ? _countryCode_egdsElementId : inquiryFormFieldSelector.COUNTRY_CODE;
            var selectedOption = (_countryCode_options = countryCode.options) === null || _countryCode_options === void 0 ? void 0 : _countryCode_options.find(function(x) {
                return x.selected;
            });
            var _selectedOption_label;
            initialFormData[countryCodeEgdsElementId] = _objectSpreadProps(_objectSpread({}, returnInitialStateObject(countryCodeEgdsElementId, countryCode.__typename, (_selectedOption_label = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) !== null && _selectedOption_label !== void 0 ? _selectedOption_label : "")), {
                options: countryCode.options
            });
            var _phoneNumber_egdsElementId;
            var phoneNumberEgdsElementId = (_phoneNumber_egdsElementId = phoneNumber.egdsElementId) !== null && _phoneNumber_egdsElementId !== void 0 ? _phoneNumber_egdsElementId : inquiryFormFieldSelector.PHONE_NUMBER;
            initialFormData[phoneNumberEgdsElementId] = returnInitialStateObject(phoneNumberEgdsElementId, phoneNumber.__typename, phoneNumber.value || "", phoneNumber.validations);
        } else if (item.__typename === "EGDSTextAreaInputField") {
            var _item_egdsElementId1;
            var egdsElementId2 = (_item_egdsElementId1 = item.egdsElementId) !== null && _item_egdsElementId1 !== void 0 ? _item_egdsElementId1 : inquiryFormFieldSelector.MESSAGE;
            var _item_value;
            initialFormData[egdsElementId2] = returnInitialStateObject(egdsElementId2, item.__typename, (_item_value = item.value) !== null && _item_value !== void 0 ? _item_value : "", item.validations);
        }
        return initialFormData;
    }, {});
    return {
        formValue: updatedFormData,
        datePicker: datePicker
    };
};
var useInquiryFormValueManager = function(form) {
    var _useState2 = _slicedToArray(useState2(getFormStateData(form.formInput, form.datePicker)), 2), formState = _useState2[0], setFormState = _useState2[1];
    var getFormValue = useCallback(function() {
        return formState;
    }, [
        formState
    ]);
    var setControlValue = function(param) {
        var id = param.id, value = param.value, error = param.error;
        setFormState(function(prevState) {
            var _prevState_formValue;
            return _objectSpreadProps(_objectSpread({}, prevState), {
                formValue: _objectSpreadProps(_objectSpread({}, prevState.formValue), _defineProperty({}, id, _objectSpreadProps(_objectSpread({}, prevState === null || prevState === void 0 ? void 0 : (_prevState_formValue = prevState.formValue) === null || _prevState_formValue === void 0 ? void 0 : _prevState_formValue[id]), {
                    value: value,
                    error: error
                })))
            });
        });
    };
    var setCheckboxControl = function(param) {
        var id = param.id, value = param.value;
        setFormState(function(prevState) {
            var _prevState_formValue;
            return _objectSpreadProps(_objectSpread({}, prevState), {
                formValue: _objectSpreadProps(_objectSpread({}, prevState.formValue), _defineProperty({}, id, _objectSpreadProps(_objectSpread({}, prevState === null || prevState === void 0 ? void 0 : (_prevState_formValue = prevState.formValue) === null || _prevState_formValue === void 0 ? void 0 : _prevState_formValue[id]), {
                    checked: value
                })))
            });
        });
    };
    var setDatePickerValue = useCallback(function(param) {
        var selectedStartDate = param.selectedStartDate, selectedEndDate = param.selectedEndDate;
        if (formState.datePicker) {
            var updatedState = _objectSpreadProps(_objectSpread({}, formState), {
                datePicker: _objectSpreadProps(_objectSpread({}, formState === null || formState === void 0 ? void 0 : formState.datePicker), {
                    selectedStartDate: selectedStartDate,
                    selectedEndDate: selectedEndDate
                })
            });
            setFormState(updatedState);
        }
    }, [
        formState
    ]);
    var createFormValueElement = function(element, error, updatedFormState) {
        var _updatedFormState_formValue;
        return _defineProperty({}, element.id, _objectSpreadProps(_objectSpread({}, (_updatedFormState_formValue = updatedFormState.formValue) === null || _updatedFormState_formValue === void 0 ? void 0 : _updatedFormState_formValue[element.id]), {
            error: error
        }));
    };
    var validate = useCallback(function() {
        var inquiryFormValidationErrors = [];
        var updatedFormState = Object.values((formState === null || formState === void 0 ? void 0 : formState.formValue) || {}).reduce(function(acc, element) {
            var currentFormState = _objectSpread({}, acc);
            var actOnServerDefinedValidation = getClientsideValidations(element.validations).actOnServerDefinedValidation;
            var currentValue = validateAndGetValues(element.typename, element.value).currentValue;
            var error = actOnServerDefinedValidation(currentValue);
            if (error === null || error === void 0 ? void 0 : error.invalid) {
                inquiryFormValidationErrors.push({
                    inputId: element.id,
                    message: error.invalid
                });
                return _objectSpreadProps(_objectSpread({}, currentFormState), {
                    formValue: _objectSpread({}, currentFormState.formValue, createFormValueElement(element, error, currentFormState))
                });
            }
            return currentFormState;
        }, formState);
        setFormState(updatedFormState);
        return !inquiryFormValidationErrors.length;
    }, [
        formState.formValue
    ]);
    return {
        setControlValue: setControlValue,
        setCheckboxControl: setCheckboxControl,
        setDatePickerValue: setDatePickerValue,
        getFormValue: getFormValue,
        formState: formState,
        validate: validate
    };
};
var InquiryFormContext = React17.createContext({});
var useInquiryFormContext = function() {
    return React17.useContext(InquiryFormContext);
};
// src/components/contact-host/__private/__fragments/inquiry-form/controls/inquiry-form-field.tsx
import React34 from "react";
import { gql as gql33 } from "@apollo/client";
// src/components/contact-host/__private/__fragments/controls/common/checkbox/egds-basic-checkbox.tsx
import React18 from "react";
import { gql as gql19 } from "@apollo/client";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { UitkCheckbox } from "uitk-react-checkbox";
var __Fragment4 = gql19(_templateObject18());
var EGDSBasicCheckBox = function(param) {
    var data = param.data, checked = param.checked, onChange = param.onChange;
    var _React18_useState = _slicedToArray(React18.useState(checked), 2), isChecked = _React18_useState[0], setIsChecked = _React18_useState[1];
    var track = useClickTracker5();
    var handleChange = React18.useCallback(function(event) {
        if (data.checkedAnalytics && !isChecked) {
            var _data_checkedAnalytics = data.checkedAnalytics, referrerId = _data_checkedAnalytics.referrerId, linkName = _data_checkedAnalytics.linkName;
            track(referrerId, linkName);
        }
        if (data.uncheckedAnalytics && isChecked) {
            var _data_uncheckedAnalytics = data.uncheckedAnalytics, referrerId1 = _data_uncheckedAnalytics.referrerId, linkName1 = _data_uncheckedAnalytics.linkName;
            track(referrerId1, linkName1);
        }
        setIsChecked(event.currentTarget.checked);
        if (onChange) {
            onChange(event);
        }
    }, [
        data.checkedAnalytics,
        data.uncheckedAnalytics,
        isChecked,
        onChange,
        track
    ]);
    if (!data.egdsElementId) {
        return null;
    }
    var _data_description, _data_name;
    return /* @__PURE__ */ React18.createElement(UitkCheckbox, {
        id: data.egdsElementId,
        checked: checked,
        description: (_data_description = data.description) !== null && _data_description !== void 0 ? _data_description : void 0,
        disabled: !data.enabled,
        name: (_data_name = data.name) !== null && _data_name !== void 0 ? _data_name : void 0,
        onChange: handleChange,
        required: data.required
    }, data.checkboxLabel.text);
};
EGDSBasicCheckBox.displayName = "EGDSBasicCheckBoxFragment";
EGDSBasicCheckBox.fragment = __Fragment4;
EGDSBasicCheckBox.fragment.__typename = "EGDSBasicCheckBox";
// src/components/contact-host/__private/__fragments/controls/egds-input-text.tsx
import React19 from "react";
import { gql as gql20 } from "@apollo/client";
import { UitkTextInput } from "uitk-react-input";
var fragment15 = gql20(_templateObject19(), fragment14);
var EGDSInputText = function(props) {
    var data = props.data, value = props.value, errorMessage = props.errorMessage, onChange = props.onChange, onBlur = props.onBlur;
    var egdsElementId = data.egdsElementId, label = data.label, placeholder = data.placeholder, inputDisabled = data.inputDisabled;
    return /* @__PURE__ */ React19.createElement(UitkTextInput, {
        id: egdsElementId || "",
        invalid: errorMessage,
        value: value || "",
        label: label,
        disabled: inputDisabled || false,
        required: false,
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : void 0,
        onBlur: onBlur,
        onChange: onChange
    });
};
EGDSInputText.displayName = "EGDSInputText";
EGDSInputText.fragment = fragment15;
// src/components/contact-host/__private/__fragments/controls/egds-text-area-input.tsx
import React20, { useEffect as useEffect2, useState as useState3 } from "react";
import { gql as gql21 } from "@apollo/client";
import { UitkTextArea } from "uitk-react-input";
var fragment16 = gql21(_templateObject20(), fragment14);
var EGDSTextAreaInputField = function(props) {
    var data = props.data, value = props.value, errorMessage = props.errorMessage, onChange = props.onChange, onBlur = props.onBlur, instructions = props.instructions;
    var egdsElementId = data.egdsElementId, minRows = data.minRows, maxRows = data.maxRows, label = data.label, placeholder = data.placeholder;
    var _useState3 = _slicedToArray(useState3(true), 2), isTextValid = _useState3[0], setIsTextValid = _useState3[1];
    useEffect2(function() {
        if (errorMessage) {
            setIsTextValid(false);
        } else {
            setIsTextValid(true);
        }
    }, [
        errorMessage
    ]);
    return /* @__PURE__ */ React20.createElement("div", null, /* @__PURE__ */ React20.createElement(UitkTextArea, {
        id: egdsElementId || "",
        invalid: !isTextValid ? instructions : "",
        value: value,
        name: label,
        label: label,
        required: false,
        minRows: minRows || void 0,
        maxRows: maxRows || void 0,
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : void 0,
        onBlur: onBlur,
        onChange: onChange,
        instruction: isTextValid ? instructions : ""
    }));
};
EGDSTextAreaInputField.displayName = "EGDSTextAreaInputField";
EGDSTextAreaInputField.fragment = fragment16;
// src/components/contact-host/__private/__fragments/controls/traveler-selector/inquiry-form-travelers-field.tsx
import React31 from "react";
import { gql as gql30 } from "@apollo/client";
// src/components/contact-host/__private/__fragments/controls/traveler-selector/egds-basic-traveler-selector.tsx
import React29 from "react";
import { gql as gql29 } from "@apollo/client";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex3 } from "uitk-react-layout-flex";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
// src/components/contact-host/__private/__fragments/controls/common/button/egds-primary-button.tsx
import React21 from "react";
import { gql as gql22 } from "@apollo/client";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize as UitkButtonSize3, UitkPrimaryButton as UitkPrimaryButton3 } from "uitk-react-button";
var __Fragment5 = gql22(_templateObject21());
var EGDSPrimaryButton = function(param) {
    var data = param.data, onClick = param.onClick, _param_isFullWidth = param.isFullWidth, isFullWidth = _param_isFullWidth === void 0 ? true : _param_isFullWidth;
    var egdsElementId = data.egdsElementId, primary = data.primary, analytics = data.analytics;
    var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_primary_button";
    var track = useClickTracker6();
    var handleClick = React21.useCallback(function() {
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            track(referrerId, linkName);
        }
        onClick();
    }, [
        analytics,
        onClick,
        track
    ]);
    return /* @__PURE__ */ React21.createElement(UitkPrimaryButton3, {
        id: id,
        onClick: handleClick,
        isFullWidth: isFullWidth,
        size: UitkButtonSize3.LARGE
    }, primary);
};
EGDSPrimaryButton.displayName = "EGDSPrimaryButton";
EGDSPrimaryButton.fragment = __Fragment5;
// src/components/contact-host/__private/__fragments/controls/traveler-selector/egds-error-summary.tsx
import React22 from "react";
import { gql as gql23 } from "@apollo/client";
import { IntersectionTracker, useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { UitkErrorSummary } from "uitk-react-error-summary";
var __Fragment6 = gql23(_templateObject22());
var EGDSErrorSummary = function(param) {
    var _param_errorCount = param.errorCount, errorCount = _param_errorCount === void 0 ? 0 : _param_errorCount, inputErrorRef = param.inputErrorRef, linkClickFocusId = param.linkClickFocusId, data = param.data;
    var _inputErrorRef_current;
    var focusHeading = React22.createRef();
    var clickTracker = useClickTracker7();
    var body = data.body, goToErrorLinkText = data.goToErrorLinkText, goToFirstErrorLinkText = data.goToFirstErrorLinkText, heading = data.heading, analytics = data.analytics, impressionAnalytics = data.impressionAnalytics, headingTemplate = data.headingTemplate;
    var hasNoErrors = errorCount === 0;
    var hasOneError = errorCount === 1;
    if (hasNoErrors) {
        return null;
    }
    var getLocalizedErrorHeading = function(errors) {
        if ((headingTemplate === null || headingTemplate === void 0 ? void 0 : headingTemplate.__typename) === "EGDSCardinalLocalizedText") {
            var headingTemplates = headingTemplate.templates.slice(1, 3);
            var key = hasOneError ? "" : headingTemplate.models[0].key;
            var template = hasOneError ? headingTemplates[0].template : headingTemplates[1].template;
            return formatLocalizedTokenString(template, key, errors.toString());
        }
        return "";
    };
    var linkText = hasOneError ? goToErrorLinkText : goToFirstErrorLinkText;
    var handleUpdate = function() {
        var _focusHeading_current;
        return focusHeading === null || focusHeading === void 0 ? void 0 : (_focusHeading_current = focusHeading.current) === null || _focusHeading_current === void 0 ? void 0 : _focusHeading_current.focus();
    };
    var _analytics_linkName;
    var renderUitkErrorSummary = /* @__PURE__ */ React22.createElement(UitkErrorSummary, {
        heading: heading.trim() ? heading : getLocalizedErrorHeading(errorCount),
        description: body === null || body === void 0 ? void 0 : body.text,
        link: linkText !== null && linkText !== void 0 ? linkText : "",
        linkClickFocus: inputErrorRef,
        linkClickFocusId: linkClickFocusId !== null && linkClickFocusId !== void 0 ? linkClickFocusId : inputErrorRef === null || inputErrorRef === void 0 ? void 0 : (_inputErrorRef_current = inputErrorRef.current) === null || _inputErrorRef_current === void 0 ? void 0 : _inputErrorRef_current.id,
        handleUpdate: handleUpdate,
        domRef: focusHeading,
        analytics: analytics ? {
            id: hasOneError ? "".concat(analytics.referrerId, ".One.Error") : "".concat(analytics.referrerId, ".Many.Errors"),
            description: (_analytics_linkName = analytics.linkName) !== null && _analytics_linkName !== void 0 ? _analytics_linkName : "",
            callback: function(id, description) {
                return clickTracker(id, description);
            }
        } : void 0
    });
    var _impressionAnalytics_referrerId, _impressionAnalytics_linkName;
    return /* @__PURE__ */ React22.createElement(React22.Fragment, null, (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) && (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) ? /* @__PURE__ */ React22.createElement(IntersectionTracker, {
        referrerId: (_impressionAnalytics_referrerId = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) !== null && _impressionAnalytics_referrerId !== void 0 ? _impressionAnalytics_referrerId : "",
        linkName: (_impressionAnalytics_linkName = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) !== null && _impressionAnalytics_linkName !== void 0 ? _impressionAnalytics_linkName : ""
    }, renderUitkErrorSummary) : renderUitkErrorSummary);
};
EGDSErrorSummary.displayName = "EGDSErrorSummaryFragment";
EGDSErrorSummary.fragment = __Fragment6;
// src/components/contact-host/__private/__fragments/controls/traveler-selector/egds-travelers.tsx
import React28 from "react";
import { gql as gql28 } from "@apollo/client";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
// src/components/contact-host/__private/__fragments/controls/traveler-selector/egds-travelers-children.tsx
import React26 from "react";
import { gql as gql27 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
// src/components/contact-host/__private/__fragments/controls/traveler-selector/egds-travelers-child-age-select.tsx
import React24 from "react";
import { gql as gql25 } from "@apollo/client";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { UitkSelect } from "uitk-react-input";
// src/components/contact-host/__private/__fragments/controls/common/egds-basic-option.tsx
import React23 from "react";
import { gql as gql24 } from "@apollo/client";
var __Fragment7 = gql24(_templateObject23());
var EGDSBasicOption = function(param) {
    var data = param.data;
    var label = data.label, value = data.value, egdsElementId = data.egdsElementId;
    var key = "".concat(egdsElementId, "-").concat(value);
    return /* @__PURE__ */ React23.createElement("option", {
        key: key,
        value: value
    }, label);
};
EGDSBasicOption.displayName = "EGDSBasicOptionFragment";
EGDSBasicOption.fragment = __Fragment7;
// src/components/contact-host/__private/__fragments/controls/traveler-selector/egds-travelers-child-age-select.tsx
var __Fragment8 = gql25(_templateObject24(), EGDSBasicOption.fragment);
var EGDSTravelerChildAgeSelect = function(param) {
    var childIndex = param.childIndex, childAgeRef = param.childAgeRef, data = param.data;
    var basicTravelersContext = useBasicTravelersContext();
    var labelTemplate = data.labelTemplate, options = data.options, egdsElementId = data.egdsElementId, value = data.value;
    var track = useClickTracker8();
    var onChange = function(event) {
        var age = parseInt(event.target.value, 10);
        var selectedOption = data.options.find(function(option) {
            return option.value === event.target.value;
        });
        if ((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.__typename) === "EGDSBasicOption" && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.changeAnalytics)) {
            var _selectedOption_changeAnalytics = selectedOption.changeAnalytics, linkName = _selectedOption_changeAnalytics.linkName, referrerId = _selectedOption_changeAnalytics.referrerId;
            var eventName = formatLocalizedTokenString(referrerId, "childNumber", String(childNumber));
            track(eventName, linkName);
        }
        if (!Number.isNaN(age)) {
            basicTravelersContext.dispatch({
                type: "UPDATE_CHILD_AGE",
                childIndex: childIndex,
                childAge: age
            });
        }
    };
    var elementName = "child-".concat(egdsElementId, "-").concat(childIndex);
    var elementId = "age-".concat(egdsElementId, "-").concat(childIndex);
    var childNumber = childIndex + 1;
    var childAge = value !== null && value !== void 0 ? value : "";
    var hasValidChildAge = Number.isInteger(childAge);
    var error = basicTravelersContext.state.error;
    var hasError = (error === null || error === void 0 ? void 0 : error.type) === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */  && error.displayConfirmation;
    var errorMessage = error && error.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */  && !hasValidChildAge && hasError ? error.message : "";
    var label = labelTemplate.__typename === "EGDSBasicLocalizedText" && labelTemplate.models.length === 1 ? formatLocalizedTokenString(labelTemplate.template, labelTemplate.models[0].key, childNumber.toString()) : "";
    return /* @__PURE__ */ React24.createElement(UitkSelect, {
        domRef: childAgeRef,
        invalid: errorMessage,
        label: label,
        id: elementId,
        name: elementName,
        onChange: onChange,
        value: childAge,
        emptyState: typeof childAge === "string"
    }, options.map(function(option) {
        return option.__typename === "EGDSBasicOption" && /* @__PURE__ */ React24.createElement(EGDSBasicOption, {
            key: "".concat(elementName, "-").concat(option.value),
            data: option
        });
    }));
};
EGDSTravelerChildAgeSelect.displayName = "EGDSTravelerChildAgeSelectFragment";
EGDSTravelerChildAgeSelect.fragment = __Fragment8;
EGDSTravelerChildAgeSelect.fragment.__typename = "EGDSTravelerChildAgeSelect";
// src/components/contact-host/__private/__fragments/controls/traveler-selector/egds-travelers-step-input.tsx
import React25 from "react";
import { gql as gql26 } from "@apollo/client";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { UitkStepInput } from "uitk-react-step-input";
var __Fragment9 = gql26(_templateObject25());
var EGDSTravelersStepInput = function(param) {
    var travelersType = param.travelersType, data = param.data;
    var label = data.label, max = data.max, min = data.min, subLabel = data.subLabel, value = data.value;
    var basicTravelersContext = useBasicTravelersContext();
    var clickTracker = useClickTracker9();
    var stepInputTexts = data.__typename === "EGDSTravelerStepInput" && {
        incrementText: data.increaseText || "",
        decrementText: data.decreaseText || ""
    };
    var onChange = function(event) {
        var count = parseInt(event.target.value, 10);
        if (data.__typename === "EGDSTravelerStepInput") {
            var increaseAnalytics = data.increaseAnalytics, decreaseAnalytics = data.decreaseAnalytics;
            if (count > value && increaseAnalytics.referrerId && increaseAnalytics.linkName) {
                clickTracker(increaseAnalytics.referrerId, increaseAnalytics.linkName);
            } else if (decreaseAnalytics.referrerId && decreaseAnalytics.linkName) {
                clickTracker(decreaseAnalytics.referrerId, decreaseAnalytics.linkName);
            }
        }
        if (!Number.isNaN(count)) {
            basicTravelersContext.dispatch({
                type: "UPDATE_TRAVELERS_COUNT",
                travelersType: travelersType,
                count: count
            });
        }
    };
    var travelerId = data.__typename === "EGDSTravelerStepInput" ? "".concat(data.egdsElementId) : "";
    return /* @__PURE__ */ React25.createElement(UitkStepInput, _objectSpreadProps(_objectSpread({}, stepInputTexts), {
        label: label,
        incrementId: "".concat(travelerId, "-increase"),
        decrementId: "".concat(travelerId, "-decrease"),
        min: min !== null && min !== void 0 ? min : 0,
        max: max !== null && max !== void 0 ? max : 0,
        onChange: onChange,
        value: value,
        description: subLabel !== null && subLabel !== void 0 ? subLabel : "",
        id: travelerId
    }));
};
EGDSTravelersStepInput.displayName = "EGDSTravelerStepInputFragment";
EGDSTravelersStepInput.fragment = __Fragment9;
EGDSTravelersStepInput.fragment.__typename = "EGDSTravelerStepInput";
// src/components/contact-host/__private/__fragments/controls/traveler-selector/egds-travelers-children.tsx
var __Fragment10 = gql27(_templateObject26(), EGDSTravelersStepInput.fragment, EGDSTravelerChildAgeSelect.fragment);
var EGDSTravelersChildren = function(param) {
    var data = param.data, childAgeRef = param.childAgeRef, travelersType = param.travelersType;
    var _data_ages;
    var count = data.count, __typename = data.__typename;
    var firstChildIndexWithNoAgeValue = 0;
    if (data === null || data === void 0 ? void 0 : data.ages) {
        var _data_ages1;
        firstChildIndexWithNoAgeValue = (_data_ages1 = data.ages) === null || _data_ages1 === void 0 ? void 0 : _data_ages1.findIndex(function(age) {
            return age.__typename === "EGDSTravelerChildAgeSelect" && age.value === null;
        });
    }
    return /* @__PURE__ */ React26.createElement(React26.Fragment, null, count && count.__typename === "EGDSTravelerStepInput" && /* @__PURE__ */ React26.createElement(EGDSTravelersStepInput, {
        travelersType: travelersType,
        data: count
    }), /* @__PURE__ */ React26.createElement(UitkLayoutFlex2, {
        wrap: "wrap"
    }, __typename === "EGDSTravelerChildren" && ((_data_ages = data.ages) === null || _data_ages === void 0 ? void 0 : _data_ages.map(function(age, childIndex) {
        return age.__typename === "EGDSTravelerChildAgeSelect" && /* @__PURE__ */ React26.createElement(React26.Fragment, {
            key: childIndex
        }, /* @__PURE__ */ React26.createElement(UitkSpacing3, {
            padding: {
                blockstart: "two",
                inlineend: "two"
            }
        }, /* @__PURE__ */ React26.createElement(UitkLayoutFlexItem2, {
            minWidth: "half_width"
        }, /* @__PURE__ */ React26.createElement("div", null, /* @__PURE__ */ React26.createElement(EGDSTravelerChildAgeSelect, {
            key: childIndex,
            childIndex: childIndex,
            data: age,
            childAgeRef: firstChildIndexWithNoAgeValue === childIndex ? childAgeRef : void 0
        })))));
    }))));
};
EGDSTravelersChildren.displayName = "EGDSTravelersChildren";
EGDSTravelersChildren.fragment = __Fragment10;
EGDSTravelersChildren.fragment.__typename = "EGDSTravelerChildren";
// src/components/contact-host/__private/__fragments/controls/traveler-selector/travelers-pets.tsx
import React27 from "react";
var TravelersPets = function(param) {
    var data = param.data;
    var _useBasicTravelersContext = useBasicTravelersContext(), state = _useBasicTravelersContext.state, dispatch = _useBasicTravelersContext.dispatch;
    var pets = state.travelers.pets;
    if ((pets === null || pets === void 0 ? void 0 : pets.__typename) !== "EGDSBasicCheckBox") {
        return null;
    }
    var checked = (pets === null || pets === void 0 ? void 0 : pets.state) === "CHECKED" /* CHECKED */ ;
    var handleOnChange = function(event) {
        dispatch({
            type: "UPDATE_PETS_FILTER",
            checked: event.currentTarget.checked
        });
    };
    return /* @__PURE__ */ React27.createElement(EGDSBasicCheckBox, {
        data: data,
        checked: checked,
        onChange: handleOnChange
    });
};
// src/components/contact-host/__private/__fragments/controls/traveler-selector/egds-travelers.tsx
var __Fragment11 = gql28(_templateObject27(), EGDSBasicCheckBox.fragment, EGDSTravelersChildren.fragment, EGDSTravelersStepInput.fragment);
var EGDSTravelers = function(param) {
    var childAgeRef = param.childAgeRef, data = param.data;
    var adults = data.adults, children = data.children, pets = data.pets;
    return /* @__PURE__ */ React28.createElement(React28.Fragment, null, adults.__typename === "EGDSTravelerStepInput" && /* @__PURE__ */ React28.createElement(UitkSpacing4, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React28.createElement("div", null, /* @__PURE__ */ React28.createElement(EGDSTravelersStepInput, {
        travelersType: "adults" /* ADULTS */ ,
        data: adults
    }))), (children === null || children === void 0 ? void 0 : children.__typename) === "EGDSTravelerChildren" && /* @__PURE__ */ React28.createElement(UitkSpacing4, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React28.createElement("div", null, /* @__PURE__ */ React28.createElement(EGDSTravelersChildren, {
        travelersType: "children" /* CHILDREN */ ,
        childAgeRef: childAgeRef,
        data: children
    }))), (pets === null || pets === void 0 ? void 0 : pets.__typename) === "EGDSBasicCheckBox" && /* @__PURE__ */ React28.createElement(UitkSpacing4, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React28.createElement("div", null, /* @__PURE__ */ React28.createElement(TravelersPets, {
        data: pets
    }))));
};
EGDSTravelers.displayName = "EGDSTravelersFragment";
EGDSTravelers.fragment = __Fragment11;
EGDSTravelers.fragment.__typename = "EGDSTravelers";
// src/components/contact-host/__private/__fragments/controls/traveler-selector/egds-basic-traveler-selector.tsx
var __Fragment12 = gql29(_templateObject28(), EGDSErrorSummary.fragment, EGDSPrimaryButton.fragment, EGDSTravelers.fragment);
var EGDSBasicTravelerSelector = function(param) {
    var onSave = param.onSave, data = param.data;
    var doneButton = data.doneButton;
    var _useBasicTravelersContext = useBasicTravelersContext(), state = _useBasicTravelersContext.state, dispatch = _useBasicTravelersContext.dispatch;
    var childAgeRef = React29.useRef(null);
    var travelers = state.travelers, error = state.error;
    var getChildrenRef = function() {
        if (childAgeRef.current) {
            return childAgeRef;
        }
    };
    var inputErrorRef = getChildrenRef();
    var handleSubmit = function() {
        if (error && error.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ ) {
            dispatch({
                type: "SHOW_ERROR"
            });
        }
        if (!error) {
            onSave(state);
        }
    };
    return /* @__PURE__ */ React29.createElement(UitkLayoutFlex3, {
        direction: "column"
    }, (error === null || error === void 0 ? void 0 : error.displayConfirmation) && /* @__PURE__ */ React29.createElement(UitkSpacing5, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React29.createElement("div", null, /* @__PURE__ */ React29.createElement(EGDSErrorSummary, {
        data: error.errorSummary,
        inputErrorRef: inputErrorRef,
        errorCount: error.errorCount
    }))), /* @__PURE__ */ React29.createElement("section", null, /* @__PURE__ */ React29.createElement(EGDSTravelers, {
        data: travelers,
        childAgeRef: childAgeRef
    })), doneButton.__typename === "UIPrimaryButton" && /* @__PURE__ */ React29.createElement(Viewport2, null, /* @__PURE__ */ React29.createElement(ViewSmall2, null, /* @__PURE__ */ React29.createElement(UitkScrim, {
        type: UitkScrimType.BUTTON
    }, /* @__PURE__ */ React29.createElement(EGDSPrimaryButton, {
        onClick: handleSubmit,
        data: doneButton
    }))), /* @__PURE__ */ React29.createElement(ViewMedium2, null, /* @__PURE__ */ React29.createElement(UitkSpacing5, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React29.createElement("div", null, /* @__PURE__ */ React29.createElement(EGDSPrimaryButton, {
        onClick: handleSubmit,
        data: doneButton
    }))))));
};
EGDSBasicTravelerSelector.displayName = "EGDSBasicTravelerSelectorFragment";
EGDSBasicTravelerSelector.fragment = __Fragment12;
EGDSBasicTravelerSelector.fragment.__typename = "EGDSBasicTravelerSelector";
// src/components/contact-host/__private/__fragments/controls/traveler-selector/travelers-basic-field-triggers.tsx
import React30 from "react";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
import { UitkDialogContent } from "uitk-react-dialog";
import { UitkForm, useFormCallback } from "uitk-react-form";
import { UitkFakeInput } from "uitk-react-input";
import { UitkList, UitkListItem } from "uitk-react-list";
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from "uitk-react-menu";
import { UitkSheet } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3 } from "uitk-react-text";
import { UitkToolbar } from "uitk-react-toolbar";
// src/components/contact-host/__private/__fragments/controls/utils/trigger-input-change-event.ts
var triggerInputChangeEvent = function(value, handler) {
    var event = new CustomEvent("change");
    var input = document.createElement("input");
    input.value = JSON.stringify(value);
    var changeListener = function(inputEvent) {
        handler(inputEvent);
    };
    input.addEventListener("change", changeListener);
    input.dispatchEvent(event);
    input.removeEventListener("change", changeListener);
};
// src/components/contact-host/__private/__fragments/controls/traveler-selector/travelers-summary.ts
var getPluralCategory = function(value) {
    if (value === 0) {
        return "ZERO" /* ZERO */ ;
    }
    if (value === 1) {
        return "ONE" /* ONE */ ;
    }
    if (value === 2) {
        return "TWO" /* TWO */ ;
    }
    if (value > 2 && value < 5) {
        return "FEW" /* FEW */ ;
    }
    if (value >= 5 && value < 10) {
        return "MANY" /* MANY */ ;
    }
    return "OTHER" /* OTHER */ ;
};
var formatCardinalText = function(cardinalText, value) {
    var useSecondaryTemplates = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var templateKey = useSecondaryTemplates ? "secondaryTemplates" : "templates";
    var cardinalTemplate = cardinalText[templateKey].find(function(template) {
        return template.category === getPluralCategory(value);
    });
    if (!cardinalTemplate) {
        return "";
    }
    return formatLocalizedTokenString(cardinalTemplate.template, cardinalText.models[0].key, value.toString());
};
// src/components/contact-host/__private/__fragments/controls/traveler-selector/travelers-basic-field-triggers.tsx
var BASE_TRAVELERS_FIELD_PREFIX = "EGDSSearchFormTravelersField-";
var ADULT_COUNT_NAME_PREFIX = "".concat(BASE_TRAVELERS_FIELD_PREFIX, "Adult");
var CHILDREN_NAME_PREFIX = "".concat(BASE_TRAVELERS_FIELD_PREFIX, "ChildrenAge");
var PETS_STATE_NAME_PREFIX = "".concat(BASE_TRAVELERS_FIELD_PREFIX, "Pets");
var ChildrenHiddenInputs = function(param) {
    var ages = param.ages, prefix = param.prefix;
    return /* @__PURE__ */ React30.createElement(React30.Fragment, null, ages.map(function(age, index) {
        if (age.__typename === "EGDSTravelerChildAgeSelect") {
            var childNumber = index + 1;
            var name = "".concat(prefix, "-").concat(childNumber);
            var _age_value;
            return /* @__PURE__ */ React30.createElement("input", {
                key: index,
                type: "hidden",
                "data-stid": name,
                name: name,
                value: (_age_value = age.value) !== null && _age_value !== void 0 ? _age_value : ""
            });
        }
        return null;
    }));
};
var BasicTravelersFieldTriggers = function(param) {
    var label = param.label, leftIcon = param.leftIcon, action = param.action, labelTemplate = param.labelTemplate;
    var analytics = action.analytics, travelerSelector = action.travelerSelector;
    var track = useClickTracker10();
    var triggerRef = React30.useRef(null);
    var _useBasicTravelersContext = useBasicTravelersContext(), dispatch = _useBasicTravelersContext.dispatch, state = _useBasicTravelersContext.state;
    var _useDialog2 = _slicedToArray(useDialog2("travelerSelectorDialog", "pwaDialogNested"), 3), dialogActions = _useDialog2[1], TravelerSelectorDialogWrapper = _useDialog2[2];
    var _React30_useState = _slicedToArray(React30.useState(false), 2), showMenu = _React30_useState[0], setShowMenu = _React30_useState[1];
    var _React30_useState1 = _slicedToArray(React30.useState(state), 2), initialState = _React30_useState1[0], setInitialState = _React30_useState1[1];
    var _React30_useState2 = _slicedToArray(React30.useState(labelTemplate === null || labelTemplate === void 0 ? void 0 : labelTemplate.text), 2), travelersSummary = _React30_useState2[0], setTravelersSummary = _React30_useState2[1];
    var handleChange = useFormCallback(travelerSelector.__typename, function(event) {
        return event;
    });
    if (travelerSelector.__typename !== "EGDSBasicTravelerSelector") {
        return null;
    }
    var onTriggerClick = function() {
        setShowMenu(function(prevState) {
            return !prevState;
        });
        track(analytics.referrerId, analytics.linkName);
    };
    var onDismissMenu = function() {
        dispatch({
            type: "RESET_STATE",
            state: initialState
        });
    };
    var onClick = function() {
        dialogActions.openDialog();
        track(analytics.referrerId, analytics.linkName);
    };
    var onDismissDialog = function() {
        dispatch({
            type: "RESET_STATE",
            state: initialState
        });
        dialogActions.closeDialog();
    };
    var updateTravelerSummary = function(travelers) {
        var _travelers_children, _travelers_pets;
        var _travelers_children_count_value;
        var childrenCount = (_travelers_children_count_value = (_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : _travelers_children.count.value) !== null && _travelers_children_count_value !== void 0 ? _travelers_children_count_value : 0;
        var travelersCount = travelers.adults.value + childrenCount;
        var isPetsChecked = (travelers === null || travelers === void 0 ? void 0 : (_travelers_pets = travelers.pets) === null || _travelers_pets === void 0 ? void 0 : _travelers_pets.__typename) === "EGDSBasicCheckBox" && travelers.pets.state === "CHECKED" /* CHECKED */ ;
        var travelersValue = formatCardinalText(labelTemplate, travelersCount, isPetsChecked);
        triggerInputChangeEvent(travelers, handleChange);
        setTravelersSummary(travelersValue);
    };
    var onSaveMenu = function(newState) {
        updateTravelerSummary(newState.travelers);
        setInitialState(newState);
        setShowMenu(function(prevState) {
            return !prevState;
        });
    };
    var onSaveDialog = function(newState) {
        updateTravelerSummary(newState.travelers);
        setInitialState(newState);
        dialogActions.closeDialog();
    };
    var _state_travelers = state.travelers, adults = _state_travelers.adults, children = _state_travelers.children, pets = _state_travelers.pets;
    return /* @__PURE__ */ React30.createElement(React30.Fragment, null, /* @__PURE__ */ React30.createElement(Viewport3, null, /* @__PURE__ */ React30.createElement(ViewMedium3, null, /* @__PURE__ */ React30.createElement(UitkMenu, {
        isOpen: showMenu,
        onTriggerClick: onTriggerClick,
        onDismiss: onDismissMenu
    }, /* @__PURE__ */ React30.createElement(UitkMenuTrigger, null, /* @__PURE__ */ React30.createElement(UitkFakeInput, {
        label: label,
        value: travelersSummary,
        icon: leftIcon,
        "data-stid": "open-room-picker"
    })), /* @__PURE__ */ React30.createElement(UitkMenuContainer, {
        autoPosition: true,
        position: PositionType.RIGHT,
        width: 375,
        showOverTrigger: true
    }, /* @__PURE__ */ React30.createElement(UitkSpacing6, {
        padding: {
            inline: "four",
            blockstart: "four"
        }
    }, /* @__PURE__ */ React30.createElement("div", null, /* @__PURE__ */ React30.createElement(UitkSpacing6, {
        padding: {
            blockend: "six"
        }
    }, /* @__PURE__ */ React30.createElement("div", null, "subTitles" in travelerSelector && (travelerSelector === null || travelerSelector === void 0 ? void 0 : travelerSelector.subTitles) && (travelerSelector === null || travelerSelector === void 0 ? void 0 : travelerSelector.subTitles.length) > 0 && /* @__PURE__ */ React30.createElement(UitkList, {
        spacing: false,
        bullet: "no-bullet",
        type: "unordered"
    }, travelerSelector === null || travelerSelector === void 0 ? void 0 : travelerSelector.subTitles.map(function(item, index) {
        return /* @__PURE__ */ React30.createElement(UitkListItem, {
            key: "listitem-".concat(index)
        }, item);
    })))), /* @__PURE__ */ React30.createElement(UitkHeading3, {
        size: 5
    }, "title" in travelerSelector ? travelerSelector.title : ""), /* @__PURE__ */ React30.createElement(EGDSBasicTravelerSelector, {
        onSave: onSaveMenu,
        data: travelerSelector
    })))))), /* @__PURE__ */ React30.createElement(ViewSmall3, null, /* @__PURE__ */ React30.createElement(React30.Fragment, null, /* @__PURE__ */ React30.createElement(UitkFakeInput, {
        domRef: triggerRef,
        label: label,
        value: travelersSummary,
        onClick: onClick,
        icon: leftIcon,
        "data-stid": "open-room-picker"
    }), /* @__PURE__ */ React30.createElement(TravelerSelectorDialogWrapper, null, /* @__PURE__ */ React30.createElement(UitkSheet, {
        type: "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React30.createElement(UitkToolbar, {
        toolbarTitle: travelerSelector.title,
        navigationContent: {
            navType: "close",
            onClick: onDismissDialog
        }
    }), /* @__PURE__ */ React30.createElement(UitkDialogContent, null, /* @__PURE__ */ React30.createElement(UitkForm, {
        hasRequiredFieldIndicator: true
    }, /* @__PURE__ */ React30.createElement(EGDSBasicTravelerSelector, {
        onSave: onSaveDialog,
        data: travelerSelector
    })))))))), /* @__PURE__ */ React30.createElement(React30.Fragment, null, /* @__PURE__ */ React30.createElement("input", {
        type: "hidden",
        "data-stid": "".concat(ADULT_COUNT_NAME_PREFIX),
        name: "".concat(ADULT_COUNT_NAME_PREFIX),
        value: adults.value
    }), (children === null || children === void 0 ? void 0 : children.__typename) === "EGDSTravelerChildren" && children.ages && /* @__PURE__ */ React30.createElement(ChildrenHiddenInputs, {
        ages: children.ages,
        prefix: CHILDREN_NAME_PREFIX
    }), (pets === null || pets === void 0 ? void 0 : pets.__typename) === "EGDSBasicCheckBox" && /* @__PURE__ */ React30.createElement("input", {
        type: "hidden",
        name: "".concat(PETS_STATE_NAME_PREFIX),
        value: pets.state
    })));
};
// src/components/contact-host/__private/__fragments/controls/traveler-selector/inquiry-form-travelers-field.tsx
var __Fragment13 = gql30(_templateObject29(), EGDSBasicTravelerSelector.fragment);
var InquiryFormTravelersField = function(param) {
    var data = param.data;
    var travelerLabel = data.travelerLabel, leftIcon = data.leftIcon, action = data.action, labelTemplate = data.labelTemplate;
    if ((action === null || action === void 0 ? void 0 : action.__typename) !== "EGDSOpenTravelerSelectorAction" || action.travelerSelector.__typename !== "EGDSBasicTravelerSelector" || !action.travelerSelector.travelers) {
        return null;
    }
    var travelers = action.travelerSelector.travelers;
    return travelers && (labelTemplate === null || labelTemplate === void 0 ? void 0 : labelTemplate.__typename) === "EGDSCardinalLocalizedText" ? /* @__PURE__ */ React31.createElement(BasicTravelersFieldTriggers, {
        label: travelerLabel !== null && travelerLabel !== void 0 ? travelerLabel : "",
        leftIcon: leftIcon === null || leftIcon === void 0 ? void 0 : leftIcon.id,
        action: action,
        labelTemplate: labelTemplate
    }) : null;
};
InquiryFormTravelersField.displayName = "InquiryFormTravelersField";
InquiryFormTravelersField.fragment = __Fragment13;
// src/components/contact-host/__private/__fragments/inquiry-form/utils/input-field-utils.ts
var isMaxLengthValidation = function(element) {
    return (element === null || element === void 0 ? void 0 : element.__typename) === "EGDSMaxLengthInputValidation";
};
var getMaxLength = function(validations) {
    var maxLengthValidation = validations === null || validations === void 0 ? void 0 : validations.find(function(validation) {
        return validation.__typename === "EGDSMaxLengthInputValidation";
    });
    return isMaxLengthValidation(maxLengthValidation) ? maxLengthValidation === null || maxLengthValidation === void 0 ? void 0 : maxLengthValidation.maxLength : Number.MAX_SAFE_INTEGER;
};
var getInstruction = function(value) {
    var validations = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], errorMessage = arguments.length > 2 ? arguments[2] : void 0;
    return {
        primary: errorMessage || "",
        secondary: "".concat(value ? value.length : 0, "/").concat(getMaxLength(validations))
    };
};
// src/components/contact-host/__private/__fragments/inquiry-form/control-state/use-inquiry-form-control-state.tsx
var useInquiryFormControlState = function(args) {
    var _currentFormState_formValue, _currentFormState_formValue_id, _currentFormState_formValue1, _currentFormState_formValue_id1;
    var inquiryFormValueManager = useInquiryFormContext().inquiryFormValueManager;
    var inputComponent = args.inputComponent;
    var hasInputValidations = function(input) {
        return "validations" in input;
    };
    var validationsForInputComponent = hasInputValidations(inputComponent) ? inputComponent.validations : void 0;
    var _inputComponent_egdsElementId;
    var id = "egdsElementId" in inputComponent ? (_inputComponent_egdsElementId = inputComponent.egdsElementId) !== null && _inputComponent_egdsElementId !== void 0 ? _inputComponent_egdsElementId : "" : "";
    var currentFormState = inquiryFormValueManager === null || inquiryFormValueManager === void 0 ? void 0 : inquiryFormValueManager.formState;
    if (!args.inputComponent || !currentFormState || !id) {
        return null;
    }
    var __typename = inputComponent.__typename;
    var _currentFormState_formValue_id_value;
    var value = (_currentFormState_formValue_id_value = (_currentFormState_formValue = currentFormState.formValue) === null || _currentFormState_formValue === void 0 ? void 0 : (_currentFormState_formValue_id = _currentFormState_formValue[id]) === null || _currentFormState_formValue_id === void 0 ? void 0 : _currentFormState_formValue_id.value) !== null && _currentFormState_formValue_id_value !== void 0 ? _currentFormState_formValue_id_value : "";
    var error = (_currentFormState_formValue1 = currentFormState.formValue) === null || _currentFormState_formValue1 === void 0 ? void 0 : (_currentFormState_formValue_id1 = _currentFormState_formValue1[id]) === null || _currentFormState_formValue_id1 === void 0 ? void 0 : _currentFormState_formValue_id1.error;
    var actOnServerDefinedValidation = getClientsideValidations(validationsForInputComponent || []).actOnServerDefinedValidation;
    var setControlValue = function(updatedControlValue, validationError) {
        inquiryFormValueManager === null || inquiryFormValueManager === void 0 ? void 0 : inquiryFormValueManager.setControlValue({
            id: id,
            value: updatedControlValue,
            typename: __typename,
            error: validationError
        });
    };
    var onBlur = function(event) {
        var updatedControlValue = event.target.value;
        var valueWithoutSpaces = clearSpaces(updatedControlValue);
        var validationError = actOnServerDefinedValidation(valueWithoutSpaces);
        var currentValue = validateAndGetValues(__typename, valueWithoutSpaces, value).currentValue;
        setControlValue(currentValue, validationError);
    };
    var onChange = function(event) {
        if (event.target.type === "checkbox" && "checked" in event.target) {
            inquiryFormValueManager === null || inquiryFormValueManager === void 0 ? void 0 : inquiryFormValueManager.setCheckboxControl({
                id: id,
                value: event.target.checked,
                typename: __typename
            });
        } else {
            var updatedControlValue = event.target.value;
            var validationError = actOnServerDefinedValidation(updatedControlValue) || [];
            setControlValue(updatedControlValue, validationError);
        }
    };
    if (inputComponent.__typename === "EGDSTextAreaInputField") {
        var _error_invalid;
        var instructionsToReturn = getInstruction(value, validationsForInputComponent, (_error_invalid = error === null || error === void 0 ? void 0 : error.invalid) !== null && _error_invalid !== void 0 ? _error_invalid : "");
        return {
            value: value,
            invalid: "",
            instructions: instructionsToReturn,
            onChange: onChange,
            onBlur: onBlur
        };
    }
    return {
        value: value,
        invalid: "",
        onChange: onChange,
        onBlur: onBlur
    };
};
// src/components/contact-host/__private/__fragments/inquiry-form/controls/inquiry-form-phone-input.tsx
import React33 from "react";
import { gql as gql32 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
// src/components/contact-host/__private/__fragments/controls/egds-input-single-select.tsx
import React32 from "react";
import { gql as gql31 } from "@apollo/client";
import { UitkSelect as UitkSelect2 } from "uitk-react-input";
var fragment17 = gql31(_templateObject30());
var EGDSInputSingleSelect = function(props) {
    var data = props.data, value = props.value, onChange = props.onChange, onBlur = props.onBlur;
    var egdsElementId = data.egdsElementId, label = data.label, disabled = data.disabled, options = data.options;
    var _React32_useMemo = _slicedToArray(React32.useMemo(function() {
        return options.filter(function(param) {
            var selected = param.selected;
            return selected;
        });
    }, [
        options
    ]), 1), selectedOption = _React32_useMemo[0];
    var selectedValue = value !== null && value !== void 0 ? value : "";
    return /* @__PURE__ */ React32.createElement(UitkSelect2, {
        id: egdsElementId || "",
        disabled: disabled,
        value: selectedValue || "",
        label: label || "",
        required: false,
        onBlur: onBlur,
        onChange: onChange,
        emptyState: !value && !selectedOption
    }, /* @__PURE__ */ React32.createElement(React32.Fragment, null, options.map(function(option) {
        return /* @__PURE__ */ React32.createElement("option", {
            key: option.label,
            value: option.label,
            label: option.label === selectedValue ? option.value : option.label
        });
    })));
};
EGDSInputSingleSelect.displayName = "EGDSInputSingleSelect";
EGDSInputSingleSelect.fragment = fragment17;
// src/components/contact-host/__private/__fragments/inquiry-form/controls/inquiry-form-phone-input.tsx
var __Fragment14 = gql32(_templateObject31(), EGDSInputSingleSelect.fragment, EGDSInputText.fragment);
var InquiryPhoneInputField = function(param) {
    var data = param.data, formValue = param.formValue;
    var _phoneFieldData_error;
    var countryCode = data.countryCode, phoneNumber = data.phoneNumber;
    var countryCodeData = formValue && formValue[countryCode.egdsElementId || ""];
    var phoneFieldData = formValue && formValue[phoneNumber.egdsElementId || ""];
    var inputPropsForCountryCode = useInquiryFormControlState({
        inputComponent: countryCode
    });
    var inputPropsForPhoneField = useInquiryFormControlState({
        inputComponent: phoneNumber
    });
    var handleCountryCodeEvent = function(handler) {
        return function(event) {
            handler(event);
            event.stopPropagation();
        };
    };
    return /* @__PURE__ */ React33.createElement(React33.Fragment, null, /* @__PURE__ */ React33.createElement(UitkLayoutFlex4, {
        tag: "div",
        space: "three",
        direction: "row"
    }, /* @__PURE__ */ React33.createElement(UitkLayoutFlexItem3, {
        maxWidth: "37x",
        grow: 1
    }, /* @__PURE__ */ React33.createElement("div", null, /* @__PURE__ */ React33.createElement(EGDSInputSingleSelect, {
        data: countryCode,
        value: countryCodeData === null || countryCodeData === void 0 ? void 0 : countryCodeData.value,
        onBlur: handleCountryCodeEvent(inputPropsForCountryCode === null || inputPropsForCountryCode === void 0 ? void 0 : inputPropsForCountryCode.onBlur),
        onChange: handleCountryCodeEvent(inputPropsForCountryCode === null || inputPropsForCountryCode === void 0 ? void 0 : inputPropsForCountryCode.onChange)
    }))), /* @__PURE__ */ React33.createElement(UitkLayoutFlexItem3, {
        grow: 1
    }, /* @__PURE__ */ React33.createElement("div", null, /* @__PURE__ */ React33.createElement(EGDSInputText, {
        data: phoneNumber,
        value: (phoneFieldData === null || phoneFieldData === void 0 ? void 0 : phoneFieldData.value) || "",
        errorMessage: phoneFieldData === null || phoneFieldData === void 0 ? void 0 : (_phoneFieldData_error = phoneFieldData.error) === null || _phoneFieldData_error === void 0 ? void 0 : _phoneFieldData_error.invalid,
        onBlur: inputPropsForPhoneField === null || inputPropsForPhoneField === void 0 ? void 0 : inputPropsForPhoneField.onBlur,
        onChange: inputPropsForPhoneField === null || inputPropsForPhoneField === void 0 ? void 0 : inputPropsForPhoneField.onChange
    })))));
};
InquiryPhoneInputField.displayName = "InquiryPhoneInputField";
InquiryPhoneInputField.fragment = __Fragment14;
// src/components/contact-host/__private/__fragments/inquiry-form/controls/inquiry-form-field.tsx
var fragment18 = gql33(_templateObject32(), EGDSInputText.fragment, EGDSBasicCheckBox.fragment, EGDSTextAreaInputField.fragment, InquiryFormTravelersField.fragment, InquiryPhoneInputField.fragment);
var InquiryFormField = function(param) {
    var data = param.data, formValues = param.formValues;
    var getFormValue = function(element, formValue) {
        var _element_egdsElementId;
        var elementId = (_element_egdsElementId = element.egdsElementId) !== null && _element_egdsElementId !== void 0 ? _element_egdsElementId : "";
        var formValueElement = formValue === null || formValue === void 0 ? void 0 : formValue[elementId];
        var _formValueElement_checked, _formValueElement_value;
        return {
            checked: (_formValueElement_checked = formValueElement === null || formValueElement === void 0 ? void 0 : formValueElement.checked) !== null && _formValueElement_checked !== void 0 ? _formValueElement_checked : false,
            value: (_formValueElement_value = formValueElement === null || formValueElement === void 0 ? void 0 : formValueElement.value) !== null && _formValueElement_value !== void 0 ? _formValueElement_value : "",
            errorMessage: formValueElement === null || formValueElement === void 0 ? void 0 : formValueElement.error
        };
    };
    var inputProps = useInquiryFormControlState({
        inputComponent: data
    });
    switch(data.__typename){
        case "EGDSSearchFormTravelersField":
            {
                var action = data.action;
                return (action === null || action === void 0 ? void 0 : action.__typename) === "EGDSOpenTravelerSelectorAction" ? /* @__PURE__ */ React34.createElement(InquiryFormTravelersField, {
                    data: data
                }) : null;
            }
        case "EGDSTextInputField":
            {
                return /* @__PURE__ */ React34.createElement(EGDSInputText, {
                    data: data,
                    value: data.value || ""
                });
            }
        case "InquiryPhoneInputField":
            {
                return /* @__PURE__ */ React34.createElement(InquiryPhoneInputField, {
                    data: data,
                    formValue: formValues.formValue
                });
            }
        case "EGDSTextAreaInputField":
            {
                var _getFormValue_errorMessage;
                var _getFormValue_errorMessage_invalid;
                return /* @__PURE__ */ React34.createElement(EGDSTextAreaInputField, {
                    data: data,
                    value: getFormValue(data, formValues.formValue).value,
                    onBlur: inputProps === null || inputProps === void 0 ? void 0 : inputProps.onBlur,
                    onChange: inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange,
                    errorMessage: (_getFormValue_errorMessage_invalid = (_getFormValue_errorMessage = getFormValue(data, formValues.formValue).errorMessage) === null || _getFormValue_errorMessage === void 0 ? void 0 : _getFormValue_errorMessage.invalid) !== null && _getFormValue_errorMessage_invalid !== void 0 ? _getFormValue_errorMessage_invalid : "",
                    instructions: inputProps === null || inputProps === void 0 ? void 0 : inputProps.instructions
                });
            }
        case "EGDSBasicCheckBox":
            {
                return /* @__PURE__ */ React34.createElement(EGDSBasicCheckBox, {
                    data: data,
                    checked: getFormValue(data, formValues.formValue).checked,
                    onChange: function(event) {
                        inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange(event);
                    }
                });
            }
        default:
            return null;
    }
};
InquiryFormField.displayName = "InquiryFormField";
InquiryFormField.fragment = fragment18;
// src/components/contact-host/__private/__fragments/inquiry-form/inquiry-form-provider.tsx
import React35 from "react";
var InquiryFormProvider = function(param) {
    var inquiryFormContext = param.inquiryFormContext, children = param.children;
    return /* @__PURE__ */ React35.createElement(InquiryFormContext.Provider, {
        value: inquiryFormContext
    }, children);
};
// src/components/contact-host/__private/__fragments/inquiry-form/inquiry-form.tsx
var __inquiryFormFragment = gql34(_templateObject33(), InquiryFormButton.fragment, InquiryFormDateRangePicker.fragment, InquiryFormField.fragment, InquiryFormDisclaimer.fragment);
var _MUTATION = gql34(_templateObject34(), ConfirmationScreen.fragment);
var InquiryForm = function(props) {
    var _data_formInput, _mutationResponse_submitInquiry;
    var data = props.data, propertyIds = props.propertyIds, onDialogClose = props.onDialogClose;
    var inquiryFormValueManager = useInquiryFormValueManager(data);
    var setInquiryUpdatedFields = useContactHostContext().setInquiryUpdatedFields;
    var getFormValue = inquiryFormValueManager.getFormValue, setCheckboxControl = inquiryFormValueManager.setCheckboxControl, setDatePickerValue = inquiryFormValueManager.setDatePickerValue;
    var _useMutation = _slicedToArray(useMutation(_MUTATION), 2), mutation = _useMutation[0], _useMutation_ = _useMutation[1], mutationResponse = _useMutation_.data, mutationError = _useMutation_.error, mutationLoading = _useMutation_.loading;
    var context = useBexApi().context;
    var _useBasicTravelersContext = useBasicTravelersContext(), travelers = _useBasicTravelersContext.state.travelers;
    var track = useEgClickstream();
    var onChangeDatePickerValue = function(selectedStartDate, selectedEndDate) {
        setDatePickerValue({
            selectedStartDate: selectedStartDate,
            selectedEndDate: selectedEndDate,
            typename: "EGDSDateRangePicker"
        });
    };
    var onFormSubmit = function() {
        var inquiryRequestInput = buildPrimaryPropertyCriteriaPayload(inquiryFormValueManager.formState, propertyIds, travelers);
        if (inquiryFormValueManager.validate()) {
            mutation({
                variables: {
                    context: context,
                    inquiryRequestInput: inquiryRequestInput
                }
            }).then(function(r) {
                var _travelers_children;
                var datePickerData = inquiryFormValueManager.formState.datePicker;
                var dateRange;
                if ((datePickerData === null || datePickerData === void 0 ? void 0 : datePickerData.selectedStartDate) && (datePickerData === null || datePickerData === void 0 ? void 0 : datePickerData.selectedEndDate)) {
                    dateRange = {
                        selectedStartDate: omitProperty(datePickerData.selectedStartDate, "__typename"),
                        selectedEndDate: omitProperty(datePickerData.selectedEndDate, "__typename")
                    };
                }
                var children = [];
                if ((travelers === null || travelers === void 0 ? void 0 : (_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : _travelers_children.__typename) === "EGDSTravelerChildren") {
                    var _travelers_children1;
                    var childAges = (_travelers_children1 = travelers.children) === null || _travelers_children1 === void 0 ? void 0 : _travelers_children1.ages;
                    childAges === null || childAges === void 0 ? void 0 : childAges.forEach(function(childAge) {
                        if (childAge.value || childAge.value === 0) {
                            children.push({
                                age: childAge.value
                            });
                        }
                    });
                }
                var rooms = [
                    {
                        adults: travelers.adults.value,
                        children: children
                    }
                ];
                var petsIncluded = travelers.pets && "state" in travelers.pets ? travelers.pets.state === "CHECKED" /* CHECKED */  : void 0;
                setInquiryUpdatedFields({
                    dateRange: dateRange,
                    rooms: rooms,
                    petsIncluded: petsIncluded
                });
            });
        }
    };
    var handleFieldChange = function(field, event, callback) {
        if (field.name === "EGDSBasicTravelerSelector") {
            if (travelers.pets && travelers.pets.__typename === "EGDSBasicCheckBox") {
                var _travelers_pets;
                var idForPets = travelers.pets.egdsElementId;
                callback({
                    id: idForPets,
                    value: ((_travelers_pets = travelers.pets) === null || _travelers_pets === void 0 ? void 0 : _travelers_pets.state) === "CHECKED"
                });
            }
        }
    };
    if (!(data === null || data === void 0 ? void 0 : data.datePicker) || !(data === null || data === void 0 ? void 0 : (_data_formInput = data.formInput) === null || _data_formInput === void 0 ? void 0 : _data_formInput.length) || !(data === null || data === void 0 ? void 0 : data.submitButton)) {
        return null;
    }
    if (mutationResponse === null || mutationResponse === void 0 ? void 0 : (_mutationResponse_submitInquiry = mutationResponse.submitInquiry) === null || _mutationResponse_submitInquiry === void 0 ? void 0 : _mutationResponse_submitInquiry.doneButton) {
        return /* @__PURE__ */ React36.createElement(ConfirmationScreen, {
            data: mutationResponse === null || mutationResponse === void 0 ? void 0 : mutationResponse.submitInquiry,
            onDialogClose: onDialogClose
        });
    }
    if (mutationError === null || mutationError === void 0 ? void 0 : mutationError.graphQLErrors.length) {
        track(buildEvent(SCHEMA_NAME, "ContactHostMessageFailed", IMPRESSION, "1.0.0" /* ONE_ZERO_ZERO */ ));
    }
    return /* @__PURE__ */ React36.createElement(React36.Fragment, null, /* @__PURE__ */ React36.createElement(UitkSpacing7, {
        padding: {
            medium: {
                inlineend: "six",
                blockend: "three"
            }
        }
    }, /* @__PURE__ */ React36.createElement(UitkLayoutFlex5, {
        alignItems: "center",
        justifyContent: "start"
    }, /* @__PURE__ */ React36.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React36.createElement(UitkHeading4, {
        tag: "h2",
        size: 5
    }, data.header)))), /* @__PURE__ */ React36.createElement(InquiryFormProvider, {
        inquiryFormContext: {
            inquiryFormValueManager: inquiryFormValueManager
        }
    }, /* @__PURE__ */ React36.createElement(UitkForm2, {
        "data-stid": "lodging-inquiry-form",
        hasRequiredFieldIndicator: true,
        onFieldChange: function(field, event) {
            return handleFieldChange(field, event, setCheckboxControl);
        }
    }, /* @__PURE__ */ React36.createElement(UitkSpacing7, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React36.createElement("div", null, /* @__PURE__ */ React36.createElement(InquiryFormDateRangePicker, {
        data: data.datePicker,
        onChange: onChangeDatePickerValue
    }))), /* @__PURE__ */ React36.createElement(UitkLayoutFlex5, {
        tag: "div",
        direction: "column",
        space: "one",
        "data-stid": "inquiry-form-container"
    }, data.formInput.map(function(input, index) {
        return /* @__PURE__ */ React36.createElement(UitkSpacing7, {
            key: "InquiryFormField-".concat(index),
            margin: {
                blockstart: "four"
            }
        }, /* @__PURE__ */ React36.createElement("div", null, /* @__PURE__ */ React36.createElement(UitkLayoutFlexItem4, {
            maxWidth: "half_width"
        }, /* @__PURE__ */ React36.createElement(InquiryFormField, {
            data: input,
            formValues: getFormValue()
        }))));
    })), data.disclaimer ? /* @__PURE__ */ React36.createElement(InquiryFormDisclaimer, {
        data: data
    }) : null, /* @__PURE__ */ React36.createElement(UitkSpacing7, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React36.createElement("div", null, /* @__PURE__ */ React36.createElement(InquiryFormButton, {
        onClick: onFormSubmit,
        localDisabled: mutationLoading,
        data: data.submitButton,
        showLoader: mutationLoading
    }))))));
};
InquiryForm.fragment = __inquiryFormFragment;
InquiryForm.displayName = "InquiryForm";
// src/components/contact-host/__private/__fragments/contact-host-inquiry-form-dialog.tsx
var _contactHostInquiryFormDialog = gql35(_templateObject35(), InquiryForm.fragment);
var isSearchFormTravelersField = function(element) {
    return element.__typename === "EGDSSearchFormTravelersField";
};
var getTravelersData = function(formInput) {
    var _travelerSelectorField_action;
    var travelerSelectorField = formInput === null || formInput === void 0 ? void 0 : formInput.find(isSearchFormTravelersField);
    return (travelerSelectorField === null || travelerSelectorField === void 0 ? void 0 : (_travelerSelectorField_action = travelerSelectorField.action) === null || _travelerSelectorField_action === void 0 ? void 0 : _travelerSelectorField_action.__typename) === "EGDSOpenTravelerSelectorAction" && travelerSelectorField.action.travelerSelector.__typename === "EGDSBasicTravelerSelector" ? travelerSelectorField.action.travelerSelector : {
        travelers: void 0,
        validations: []
    };
};
var Sheet = function(props) {
    var data = props.data, onDialogClose = props.onDialogClose, onFieldsChangeCallback = props.onFieldsChangeCallback, dialogId = props.dialogId;
    var _useContactHostContext = useContactHostContext(), sheetViewType = _useContactHostContext.sheetViewType, propertyIds = _useContactHostContext.propertyIds, inquiryUpdatedFields = _useContactHostContext.inquiryUpdatedFields, setInquiryUpdatedFields = _useContactHostContext.setInquiryUpdatedFields;
    var trackEvent = useEgClickstream2();
    var triggerRef = useRef(null);
    var _useDialog3 = _slicedToArray(useDialog3(dialogId), 3), isDialogOpen = _useDialog3[0], dialogActions = _useDialog3[1], DialogComponent = _useDialog3[2];
    useEffect3(function() {
        dialogActions.openDialog();
        trackEvent(inquiryFormViewedEvent());
    }, []);
    var closeDialog = function() {
        if (onFieldsChangeCallback && inquiryUpdatedFields) {
            var dateRange = inquiryUpdatedFields.dateRange, petsIncluded = inquiryUpdatedFields.petsIncluded, rooms = inquiryUpdatedFields.rooms;
            var payload = {
                dateRange: dateRange ? {
                    selectedStartDate: dateRange.selectedStartDate,
                    selectedEndDate: dateRange.selectedEndDate
                } : void 0,
                rooms: rooms,
                petsIncluded: petsIncluded
            };
            onFieldsChangeCallback(payload);
            setInquiryUpdatedFields(void 0);
        }
        onDialogClose(false);
        dialogActions.closeDialog();
    };
    var _getTravelersData = getTravelersData(data.formInput), travelers = _getTravelersData.travelers, validations = _getTravelersData.validations;
    return /* @__PURE__ */ React37.createElement(DialogComponent, null, /* @__PURE__ */ React37.createElement(UitkSheet2, {
        isVisible: isDialogOpen,
        triggerRef: triggerRef,
        type: sheetViewType
    }, /* @__PURE__ */ React37.createElement(UitkToolbar2, {
        navigationContent: {
            onClick: closeDialog,
            navIconLabel: "Close Toolbar"
        }
    }), /* @__PURE__ */ React37.createElement(UitkSheetContent, null, travelers && /* @__PURE__ */ React37.createElement(BasicTravelersProvider, _objectSpread({}, {
        travelers: travelers,
        validations: validations
    }), /* @__PURE__ */ React37.createElement(InquiryForm, {
        data: data,
        propertyIds: propertyIds,
        onDialogClose: closeDialog
    })))));
};
var ContactHostInquiryFormDialog = function(props) {
    var data = props.data, handleInquiryFormDialogVisibility = props.handleInquiryFormDialogVisibility, onFieldsChangeCallback = props.onFieldsChangeCallback, dialogId = props.dialogId;
    if (data === null || data === void 0 ? void 0 : data.inquiryFormModal) {
        return /* @__PURE__ */ React37.createElement(Sheet, {
            data: data === null || data === void 0 ? void 0 : data.inquiryFormModal,
            onDialogClose: handleInquiryFormDialogVisibility,
            onFieldsChangeCallback: onFieldsChangeCallback,
            dialogId: dialogId
        });
    }
    return null;
};
ContactHostInquiryFormDialog.fragment = _contactHostInquiryFormDialog;
ContactHostInquiryFormDialog.displayName = "ContactHostInquiryFormDialog";
// src/components/contact-host/__private/__fragments/contact-host-button.tsx
var __contactHostButtonFragment = gql36(_templateObject36(), ContactHostInquiryFormDialog.fragment);
var DIALOG_ID = "centered-sheet-necessary-dialog-layer";
var usePrevious = function(value) {
    var ref = useRef2({
        search: ""
    });
    useEffect4(function() {
        ref.current = value;
    });
    return ref.current;
};
var ContactHostButton = function(param) {
    var onFieldsChangeCallback = param.onFieldsChangeCallback, data = param.data;
    var _useState4 = _slicedToArray(useState4(false), 2), showInquiryFormDialog = _useState4[0], setShowInquiryFormDialog = _useState4[1];
    var search = useLocation().search;
    var trackEvent = useClickTracker11();
    var button = data.button, action = data.action;
    var _useDialog4 = _slicedToArray(useDialog4(DIALOG_ID), 1), isDialogOpen = _useDialog4[0];
    var prevSearch = usePrevious({
        search: search
    });
    var _useContactHostContext = useContactHostContext(), isInquiryRoute = _useContactHostContext.isInquiryRoute, setIsInquiryRoute = _useContactHostContext.setIsInquiryRoute;
    useEffect4(function() {
        if (search.includes("action=inquiry") && !isInquiryRoute) {
            setIsInquiryRoute(true);
            setShowInquiryFormDialog(true);
        }
    }, [
        search
    ]);
    useEffect4(function() {
        if (!isDialogOpen && (!search.includes("action=inquiry") || search.includes("action=inquiry") && prevSearch.search.includes("action=inquiry"))) {
            setShowInquiryFormDialog(false);
        }
    }, [
        isDialogOpen
    ]);
    var handleButtonClick = function(buttonAction) {
        if (button === null || button === void 0 ? void 0 : button.analytics) {
            var analytics = button.analytics;
            trackEvent(analytics.referrerId, analytics.linkName, true);
        }
        if ((buttonAction === null || buttonAction === void 0 ? void 0 : buttonAction.__typename) === "InquiryFormDialogAction") {
            setShowInquiryFormDialog(true);
        }
    };
    var getButtonProps = function() {
        var buttonProps = {
            onClick: function() {
                return handleButtonClick(action);
            }
        };
        if ((action === null || action === void 0 ? void 0 : action.__typename) === "UILinkAction") {
            var resource = action.resource;
            buttonProps = _objectSpreadProps(_objectSpread({}, buttonProps), {
                href: resource.value
            });
        }
        return buttonProps;
    };
    var renderButton = function() {
        switch(button === null || button === void 0 ? void 0 : button.__typename){
            case "UISecondaryButton":
                return /* @__PURE__ */ React38.createElement(UitkSecondaryButton, _objectSpread({
                    "data-stid": "contact-host-secondary-button"
                }, getButtonProps()), button === null || button === void 0 ? void 0 : button.primary);
            case "UITertiaryButton":
                return /* @__PURE__ */ React38.createElement(UitkTertiaryButton, _objectSpread({
                    "data-stid": "contact-host-tertiary-button"
                }, getButtonProps()), button === null || button === void 0 ? void 0 : button.primary);
            default:
                return null;
        }
    };
    return /* @__PURE__ */ React38.createElement(React38.Fragment, null, button && renderButton(), (action === null || action === void 0 ? void 0 : action.__typename) === "InquiryFormDialogAction" && showInquiryFormDialog && /* @__PURE__ */ React38.createElement(ContactHostInquiryFormDialog, {
        dialogId: DIALOG_ID,
        data: action,
        handleInquiryFormDialogVisibility: setShowInquiryFormDialog,
        onFieldsChangeCallback: onFieldsChangeCallback
    }));
};
ContactHostButton.fragment = __contactHostButtonFragment;
ContactHostButton.displayName = "ContactHostButton";
// src/components/contact-host/__private/__fragments/contact-host-section.tsx
var __contactHostSectionFragment = gql37(_templateObject37(), ContactHostButton.fragment);
var ContactHostSection = function(param) {
    var data = param.data, onFieldsChangeCallback = param.onFieldsChangeCallback;
    var header = data.header, cta = data.cta;
    if (!cta) {
        return null;
    }
    var renderContactHostButtonWithheader = function() {
        return /* @__PURE__ */ React39.createElement(UitkCard, null, /* @__PURE__ */ React39.createElement(UitkCardContentSection, null, /* @__PURE__ */ React39.createElement(UitkSpacing8, {
            padding: {
                large: {
                    inline: "three"
                },
                extra_large: {
                    inline: "three"
                },
                blockstart: "three",
                blockend: "three"
            }
        }, /* @__PURE__ */ React39.createElement(UitkLayoutGrid, {
            space: "four",
            columns: {
                medium: 1,
                large: 3
            }
        }, /* @__PURE__ */ React39.createElement(UitkLayoutGridItem2, {
            colSpan: {
                medium: 1,
                large: 1
            },
            rowSpan: {
                medium: 1,
                large: 1
            }
        }, /* @__PURE__ */ React39.createElement(UitkHeading5, {
            tag: "h3",
            size: 4
        }, header)), /* @__PURE__ */ React39.createElement(UitkLayoutGridItem2, {
            colSpan: 1
        }, /* @__PURE__ */ React39.createElement("div", null, /* @__PURE__ */ React39.createElement(ContactHostButton, {
            data: cta,
            onFieldsChangeCallback: onFieldsChangeCallback
        })))))));
    };
    return /* @__PURE__ */ React39.createElement(React39.Fragment, null, header ? renderContactHostButtonWithheader() : /* @__PURE__ */ React39.createElement(ContactHostButton, {
        data: cta,
        onFieldsChangeCallback: onFieldsChangeCallback
    }));
};
ContactHostSection.fragment = __contactHostSectionFragment;
ContactHostSection.displayName = "ContactHostSection";
// src/components/contact-host/contact-host.tsx
var __Query = gql38(_templateObject38(), ContactHostSection.fragment);
var ContactHost = function(props) {
    var _variables_inquiryFormInput, _variables_inquiryFormInput_primaryPropertyCriteriaInput;
    var inputs = props.inputs, skipSsr = props.skipSsr, onFieldsChangeCallback = props.onFieldsChangeCallback;
    var context = useBexApi2().context;
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useContactHostContext = useContactHostContext(), setPropertyIds = _useContactHostContext.setPropertyIds, setSheetViewType = _useContactHostContext.setSheetViewType;
    var sheetViewType = context.device.type === "MOBILE_PHONE" /* MOBILE_PHONE */  ? "full" : "centered";
    var propertyIds = (_variables_inquiryFormInput = variables.inquiryFormInput) === null || _variables_inquiryFormInput === void 0 ? void 0 : (_variables_inquiryFormInput_primaryPropertyCriteriaInput = _variables_inquiryFormInput.primaryPropertyCriteriaInput) === null || _variables_inquiryFormInput_primaryPropertyCriteriaInput === void 0 ? void 0 : _variables_inquiryFormInput_primaryPropertyCriteriaInput.destination.propertyIds;
    propertyIds && setPropertyIds(propertyIds);
    setSheetViewType(sheetViewType);
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.contactHost)) {
        return null;
    }
    return /* @__PURE__ */ React40.createElement(ContactHostSection, {
        data: data.contactHost,
        onFieldsChangeCallback: onFieldsChangeCallback
    });
};
ContactHost.displayName = "ContactHost";
export { ContactHost, ContactHostContextProvider };
//# sourceMappingURL=index.js.map